<template>
  <section
    id="workflow-users-list"
    class="!bg-white !p-3 rounded-xl !border !border-page-border h-mainCardHeight !overflow-y-auto"
  >
    <el-tabs
      type="card"
      @tab-click="handleClick"
      v-model="activeTab"
      :style="getIsMobile ? 'margin-top:8px' : ''"
      v-if="!fromAppliedFilter"
    >
      <el-tab-pane label="Need to be Approved" name="need_to_be_approved">
        <span slot="label">
          Need to be Approved
          <div class="count-circle" style="background-color: #007bff">
            {{ needToApproveCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane :label="approvalHoldName ? approvalHoldName : 'HOLD'" name="hold">
        <span slot="label">
          {{ approvalHoldName ? approvalHoldName : 'HOLD' }}
          <div class="count-circle" style="background-color: #f2dd27">
            {{ holdCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Waiting for others" name="waiting_for_others">
        <span slot="label">
          Waiting for others
          <div class="count-circle" style="background-color: #e6a23c">
            {{ needToApproveOthersCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Approved" name="approved">
        <span slot="label">
          Approved
          <div class="count-circle" style="background-color: #67c23a">
            {{ approvedCount }}
          </div>
        </span>
      </el-tab-pane>
      <el-tab-pane label="Rejected" name="rejected">
        <span slot="label">
          Rejected
          <div class="count-circle" style="background-color: #f56c6c">
            {{ rejectedCount }}
          </div>
        </span>
      </el-tab-pane>
    </el-tabs>
    <div class="container mb-4 !pl-0 !ml-0 !mt-2 !max-w-full">
      <div v-if="selectedRowsIds.length > 0">
        <el-dropdown>
          <button
            class="!bg-brand-500 text-xs 2xl:text-smd text-white !py-1.5 !px-4 !rounded-md !border-none"
            type="button"
          >
            Bulk Actions
          </button>
          <el-dropdown-menu
            slot="dropdown"
            v-if="
              activeTab !== 'approved' &&
              activeTab !== 'rejected' &&
              activeTab !== 'waiting_for_others'
            "
          >
            <template>
              <a @click="approveAllChecked">
                <el-dropdown-item command="approve">
                  <i class="fa fa-check"></i>
                  Approve
                </el-dropdown-item>
              </a>
              <a @click="holdAllChecked">
                <el-dropdown-item command="approve">
                  <i class="fa fa-hourglass-half"></i>
                  {{ approvalHoldName }}
                </el-dropdown-item>
              </a>
              <a @click="showBulkRejectConfirm">
                <el-dropdown-item command="reject">
                  <i class="fa fa-times"></i>
                  Reject
                </el-dropdown-item>
              </a>
            </template>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="filter-container !justify-right gap-2 flex-row-reverse !w-full">
        <div class="filter-icon-box" v-if="haveOneFormbuilder">
          <button class="!rounded-sm !p-1" type="button" @click="openSettingsModal">
            <img src="@/assets/img/icons/new/settings-icon.svg" alt="" class="!size-4" />
          </button>
        </div>
        <div class="filter-icon-box">
          <img src="@/assets/img/icons/new/filter-icon.svg" alt="" class="!size-4" />
        </div>
        <el-select
          v-model="selectedFilterFormbuilderids"
          placeholder="Filter by Form Name"
          size="mini"
          multiple
          collapse-tags
          clearable
          @change="fetchAllEmployee"
        >
          <el-option
            v-for="item in allFormbuildersDetails"
            :key="item._id"
            :label="item.name"
            :value="item._id"
          ></el-option>
        </el-select>
        <el-select
          v-if="activeTab == 'approved'"
          v-model="approvedAtFilter"
          @change="onApprovedAtChange"
          placeholder="Filter by Approved At"
          size="mini"
          class="ml-1"
          clearable
        >
          <el-option
            v-for="filter in dateFilters"
            :key="filter.value"
            :label="filter.label"
            :value="filter.value"
          />
        </el-select>
        <div class="ml-1" v-if="approvedAtFilter == 'custom_date_range'">
          <el-date-picker
            v-model="approvedAtCustomDateRange"
            type="daterange"
            format="MM-dd-yyyy"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="onApprovedAtDateRangeChange"
            size="mini"
          />
        </div>
        <el-select
          v-if="activeTab == 'rejected'"
          v-model="rejectedAtFilter"
          @change="onRejectedAtChange"
          placeholder="Filter by Rejected At"
          size="mini"
          class="ml-1"
          clearable
        >
          <el-option
            v-for="filter in dateFilters"
            :key="filter.value"
            :label="filter.label"
            :value="filter.value"
          />
        </el-select>
        <div class="ml-1" v-if="rejectedAtFilter == 'custom_date_range'">
          <el-date-picker
            v-model="rejectedAtCustomDateRange"
            type="daterange"
            format="MM-dd-yyyy"
            start-placeholder="Start date"
            end-placeholder="End date"
            @change="onRejectedAtDateRangeChange"
            size="mini"
          />
        </div>
      </div>
    </div>
    <div class="inner-navbar-content top">
      <div class="vue-data-table-default approval-form">
        <el-table
          :data="data"
          :total="total"
          :resizable="true"
          border
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          @expand-change="fetchFormbuilderData"
          v-loading="loading || resendLoading"
          element-loading-spinner="el-icon-loading"
          :element-loading-text="
            loadingText ? loadingText : 'Fetching approval data, please wait...'
          "
          v-if="!getIsMobile"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55" prop="selection"></el-table-column>
          <el-table-column type="expand" label="  " width="50">
            <template slot-scope="scope" id="expand">
              <div
                v-loading="detailedDataLoadingMap[scope.row._id]"
                element-loading-text="Loading data, please wait..."
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.8)"
                class="expand-loading-wrapper"
              >
                <div
                  v-if="
                    !detailedDataLoadingMap[scope.row._id] &&
                    scope.row &&
                    scope.row.steps_fields_data
                  "
                  class="expand-content"
                >
                  <div v-for="(step, stepIndex) in scope.row.steps_fields_data" :key="stepIndex">
                    <div v-if="step.type == 'ENTITY'">
                      <div
                        v-for="(template, templateIndex) in step.templates"
                        :key="templateIndex"
                        class="template-section"
                      >
                        <div>
                          <h4 class="template-title">
                            {{ template.template_name }}
                          </h4>
                        </div>

                        <div
                          v-for="(fieldRow, rowIndex) in chunkFields(template.fields, 3)"
                          :key="rowIndex"
                          class="field-row"
                        >
                          <div v-for="(field, fieldIndex) in fieldRow" :key="fieldIndex">
                            <div class="field-item">
                              <strong>{{ field.label }}:</strong>
                              <div v-if="field.inputType === 'FILE'">
                                <el-button
                                  type="text"
                                  @click="downloadFile(field.data_key, scope.row)"
                                  v-if="getValueByKey(scope.row, field)"
                                >
                                  <p style="font-size: 13px">
                                    {{ getValueByKey(scope.row, field) | truncate(20, '...') }}
                                    <i class="el-icon-download m-rl-2"></i>
                                  </p>
                                </el-button>
                              </div>
                              <div v-else-if="field.inputType === 'SIGNATURE'">
                                <img
                                  :src="getValueByKey(scope.row, field)"
                                  alt="Signature"
                                  class="image-field"
                                />
                              </div>
                              <div v-else>
                                {{ getValueByKey(scope.row, field) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-else-if="step.type == 'TEMPLATE'">
                      <div class="template-section">
                        <div class="template-header">
                          <h4 class="template-title">
                            {{ step.template_name }}
                          </h4>
                        </div>

                        <div
                          v-for="(fieldRow, rowIndex) in chunkFields(step.fields, 3)"
                          :key="rowIndex"
                          class="field-row"
                        >
                          <div v-for="(field, fieldIndex) in fieldRow" :key="fieldIndex">
                            <div class="field-item">
                              <strong>{{ field.label }}:</strong>
                              <div v-if="field.inputType === 'FILE'">
                                <el-button
                                  type="text"
                                  @click="downloadFile(field.data_key, scope.row)"
                                  v-if="getValueByKey(scope.row, field)"
                                >
                                  <p style="font-size: 13px">
                                    {{ getValueByKey(scope.row, field) | truncate(20, '...') }}
                                    <i class="el-icon-download m-rl-2"></i>
                                  </p>
                                </el-button>
                              </div>
                              <div v-else-if="field.inputType === 'SIGNATURE'">
                                <img
                                  :src="getValueByKey(scope.row, field)"
                                  alt="Signature"
                                  class="image-field"
                                />
                              </div>
                              <div v-else>
                                {{ getValueByKey(scope.row, field) }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="Form Name"
            v-if="selectedTableFields.includes('form_name')"
          >
            <template slot-scope="scope" id="form_name">
              <template v-if="scope.row.isFormLabel && scope.row.customized_form_name">
                {{ scope.row.customized_form_name }}
              </template>
              <template v-else>
                <div
                  v-if="
                    scope.row &&
                    scope.row.formbuilders_details_id &&
                    scope.row.formbuilders_details_id.name
                  "
                  style="word-break: break-word; padding-top: 12px; padding-bottom: 12px"
                >
                  {{ scope.row.formbuilders_details_id.name | truncate(20, '...') }}

                  <!-- Append separator + selected field values if isFormLabel is true -->
                  <template v-if="scope.row.formbuilders_details_id.customization?.isFormLabel">
                    {{ formatFormNameWithLabels(scope.row) }}
                  </template>
                </div>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            label="Form ID"
            min-width="140"
            sortable="custom"
            v-if="isGenerateUniqueId"
          >
            <template slot-scope="scope">
              <div class="d-flex">
                {{ scope.row.formbuilderdata_unique_id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="User name"
            width="150"
            v-if="selectedTableFields.includes('user_name')"
          >
            <template slot-scope="scope" id="user_name">
              <div class="d-flex" v-if="!isAnonymousForm(scope.row)">
                <div style="word-break: break-word">
                  {{ getUserName(scope.row) }}
                </div>
              </div>
              <div v-else>
                <el-popover
                  placement="top-start"
                  title="User info"
                  width="300"
                  trigger="hover"
                  v-if="
                    scope.row &&
                    scope.row.formbuilders_details_id &&
                    scope.row.formbuilders_details_id.primary_fields
                  "
                >
                  <div slot="reference">
                    <i class="el-icon-info"></i>
                    <span class="d-inline-block pl-10">ANONYMOUS</span>
                  </div>
                  <div>
                    <div
                      v-for="op in scope.row.formbuilders_details_id.primary_fields"
                      :key="op + '_key'"
                    >
                      {{ getFormbuilderFieldValue(op, scope.row) }}
                    </div>
                  </div>
                </el-popover>
                <div v-else>ANONYMOUS</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="User email / User IP Address"
            min-width="250"
            v-if="selectedTableFields.includes('user_email')"
          >
            <template slot-scope="scope" id="user_email">
              <div class="d-flex" v-if="!isAnonymousForm(scope.row)">
                <div>{{ getUserEmail(scope.row) }}</div>
              </div>
              <div v-else>
                <div>{{ scope.row.ip_address }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column v-if="hasIntervals" label="Submitted For" min-width="150">
            <template slot-scope="scope" id="sumitted_for">
              <div>
                <span class="black-coral sm-80" v-if="scope.row.time_interval">
                  {{ scope.row.time_interval | moment(fequencyDateMap[intervalType]) }}
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="Approval Status"
            min-width="180"
            v-if="selectedTableFields.includes('approval_status')"
          >
            <template slot-scope="scope" id="approval_status">
              <template v-if="!isAdvancedApproval(scope.row)">
                <div class="success" v-if="scope.row.approval_status == 'APPROVED'">
                  <el-popover
                    placement="top-start"
                    title="Approval details:"
                    width="300"
                    trigger="hover"
                  >
                    <div v-if="scope.row.priority_based">
                      <span
                        v-if="getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_by"
                      >
                        Approved by: {{ getApprovedUser(scope.row).approved_by }}
                      </span>
                      <br />
                      <span
                        v-if="getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_at"
                      >
                        Approved on:
                        {{
                          convertToLocalDateTime(getApprovedUser(scope.row).approved_at)
                            | globalDateTimeFormat
                        }}
                      </span>
                      <br />
                      <span
                        v-if="
                          getApprovedUser(scope.row) && getApprovedUser(scope.row).approved_reason
                        "
                      >
                        Approved Reason:
                        {{ getApprovedUser(scope.row).approved_reason }}
                      </span>
                    </div>
                    <div v-else>
                      <ul>
                        <li
                          v-for="approver in getApprovedUser(scope.row)"
                          :key="approver._id"
                          class="list-style"
                        >
                          <div v-if="approver.approved_by && approver.approved_at">
                            <i class="el-icon-user-solid icon-style"></i>
                            Approved by:
                            <span class="approver-text">
                              {{ ' ' + approver.approved_by + ',' }}
                            </span>
                            <br />
                            <i class="el-icon-time icon-style"></i>
                            Approved at:
                            <span class="approver-text">
                              {{
                                (' ' + convertToLocalDateTime(approver.approved_at))
                                  | globalDateTimeFormat
                              }}
                            </span>
                            <br />
                            <span v-if="approver.approved_reason">
                              <i class="el-icon-edit-outline icon-style"></i>
                              Approved reason:
                              <span class="approver-text">
                                {{ ' ' + approver.approved_reason }}
                              </span>
                            </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div slot="reference">
                      <i class="el-icon-success"></i>
                      <span class="d-inline-block pl-10">
                        {{ scope.row.approval_status == 'APPROVED' ? 'Approved' : '' }}
                      </span>
                      <el-tooltip
                        trigger="hover"
                        effect="dark"
                        content="Revoke Approval"
                        placement="right"
                        v-if="
                          scope.row.allow_revoke_approval &&
                          checkRevokePermission('approved', scope.row) &&
                          scope.row.approval_status == 'APPROVED'
                        "
                      >
                        <el-link
                          type="warning"
                          @click="showRevokeApprovalConfirm(scope.row)"
                          :underline="false"
                        >
                          <i class="fa fa-level-up"></i>
                        </el-link>
                      </el-tooltip>
                    </div>
                  </el-popover>
                </div>
                <div class="error" v-else-if="scope.row.approval_status == 'REJECTED'">
                  <el-popover
                    placement="top-start"
                    title="Rejection details:"
                    width="300"
                    trigger="hover"
                  >
                    <div>
                      <span
                        v-if="getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_by"
                      >
                        Rejected by: {{ getRejectedUser(scope.row).rejected_by }}
                      </span>
                      <br />
                      <span
                        v-if="getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_at"
                      >
                        Rejected on:
                        {{
                          convertToLocalDateTime(getRejectedUser(scope.row).rejected_at)
                            | globalDateTimeFormat
                        }}
                      </span>
                      <br />
                      <span
                        v-if="
                          getRejectedUser(scope.row) && getRejectedUser(scope.row).rejected_reason
                        "
                        style="word-break: break-word"
                      >
                        Reason:
                        {{ getRejectedUser(scope.row).rejected_reason }}
                      </span>
                    </div>
                    <div slot="reference" class="expired-div">
                      <i class="el-icon-error"></i>
                      <span class="d-inline-block pl-10">
                        {{ scope.row.approval_status == 'REJECTED' ? 'Rejected' : '' }}
                        <el-tooltip
                          trigger="hover"
                          effect="dark"
                          content="Revoke Approval"
                          placement="right"
                          v-if="
                            scope.row.allow_revoke_approval &&
                            checkRevokePermission('rejected', scope.row) &&
                            scope.row.approval_status == 'REJECTED'
                          "
                        >
                          <el-link
                            type="warning"
                            @click="showRevokeApprovalConfirm(scope.row)"
                            :underline="false"
                          >
                            <i class="fa fa-level-up"></i>
                          </el-link>
                        </el-tooltip>
                      </span>
                    </div>
                  </el-popover>
                </div>
                <div
                  :class="
                    getReviewerData(scope.row) && getReviewerData(scope.row).status == 'REJECTED'
                      ? 'error'
                      : 'success'
                  "
                  v-else-if="checkReviewer(scope.row)"
                >
                  <el-popover
                    placement="top-start"
                    :title="getReviewerData(scope.row).title"
                    width="300"
                    trigger="hover"
                  >
                    <div>
                      <span v-if="getReviewerData(scope.row).label1">
                        {{ getReviewerData(scope.row).label1 }}
                      </span>
                      <br />
                      <span v-if="getReviewerData(scope.row).date">
                        On: {{ getReviewerData(scope.row).date | globalDateTimeFormat }}
                      </span>
                      <br />
                      <span v-if="getReviewerData(scope.row).reason" style="word-break: break-word">
                        Reason:
                        {{ getReviewerData(scope.row).reason }}
                      </span>
                    </div>
                    <div slot="reference">
                      <i
                        :class="
                          getReviewerData(scope.row).status == 'REJECTED'
                            ? 'el-icon-error'
                            : 'el-icon-success'
                        "
                      ></i>
                      <span class="d-inline-block" style="word-break: break-word">
                        {{
                          getReviewerData(scope.row).status +
                          ' by ' +
                          getReviewerData(scope.row).user_name
                        }}
                      </span>
                    </div>
                  </el-popover>
                </div>
                <div class="warning d-flex" v-else>
                  <span class="d-inline-block pl-10">
                    {{ scope.row.approval_status == 'HOLD' ? approvalHoldName : 'Pending' }}
                  </span>
                  <formbuilderLogs
                    class="primary"
                    :currentFormbuilderData="scope.row"
                    :allEntitiesData="allEntitiesData"
                    :allCompanyUserTypesData="allCompanyUserTypesData"
                    v-on:reload-table="fetchAllEmployee"
                  ></formbuilderLogs>
                </div>
              </template>
              <template v-else>
                <span class="warning" v-if="scope.row.approval_status == 'PENDING'">
                  <i class="el-icon-time"></i>
                  Pending
                </span>
                <span class="success" v-if="scope.row.approval_status == 'APPROVED'">
                  <i class="el-icon-success"></i>
                  Approved
                </span>
                <span class="error" v-if="scope.row.approval_status == 'REJECTED'">
                  <i class="el-icon-error"></i>
                  Rejected
                </span>

                <el-tooltip content="Detailed Logs" effect="dark" placement="top">
                  <el-button type="text" @click="openAdvancedLogs(scope.row)">
                    <i class="fa fa-external-link"></i>
                  </el-button>
                </el-tooltip>
              </template>
            </template>
          </el-table-column>

          <template v-if="allFields.length > 0 && haveOneFormbuilder" id="field_columns">
            <el-table-column
              class="tableView"
              v-for="(field, index) of allFields
                .filter(
                  (e) =>
                    e.input_type !== 'DATA_TABLE' &&
                    e.input_type !== 'ENTITY_TABLE' &&
                    (selectedTableFields.includes(e.data_key) || !selectedTableFields.length)
                )
                .filter((e) => contentFields.indexOf(e.input_type) === -1)"
              :key="index"
              :label="getTruncatedLabel(field.label)"
              :prop="field.data_key"
              width="200"
            >
              <template slot-scope="scope">
                <div v-if="field.inputType === 'SIGNATURE'">
                  <img
                    :src="getFormbuilderFieldValue(field.data_key, scope.row)"
                    alt="Signature"
                    class="image-field"
                  />
                </div>
                <div v-else-if="field.inputType === 'FILE'">
                  <el-button
                    type="text"
                    @click="getFormbuilderFieldValue(field.data_key, scope.row, true)"
                    v-if="getFormbuilderFieldValue(field.data_key, scope.row)"
                  >
                    <p style="font-size: 13px">
                      {{
                        getFormbuilderFieldValue(field.data_key, scope.row) | truncate(20, '...')
                      }}
                      <i class="el-icon-download m-rl-2"></i>
                    </p>
                  </el-button>
                </div>
                <div v-else>
                  {{ getFormbuilderFieldValue(field.data_key, scope.row) }}
                </div>
              </template>
            </el-table-column>
          </template>

          <el-table-column
            label="Sent Status"
            min-width="150"
            v-if="selectedTableFields.includes('sent_status')"
          >
            <template slot-scope="scope" id="sent_status">
              <div>
                <span v-if="scope.row.sent_at" class="d-block yale-blue sm-80 line-height-1">
                  Sent On
                </span>
                <span class="black-coral sm-80" v-if="scope.row.sent_at">
                  {{ scope.row.sent_at | moment('MM-DD-YYYY HH:mm') }}
                </span>

                <span v-if="!scope.row.sent_at" class="d-block yale-blue sm-80 line-height-1">
                  Not Send
                </span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            label="Completion Status"
            width="170"
            v-if="selectedTableFields.includes('completion_status')"
          >
            <template slot-scope="scope" id="completion_status">
              <div
                class="warning"
                v-if="
                  scope.row.formbuilder_data_status == 'PENDING' ||
                  scope.row.formbuilder_data_status == 'SENT'
                "
              >
                <i class="el-icon-refresh"></i>
                <span class="d-inline-block pl-10">
                  {{
                    scope.row.formbuilder_data_status == 'PENDING' ||
                    scope.row.formbuilder_data_status == 'SENT'
                      ? 'Pending'
                      : ''
                  }}
                </span>
              </div>

              <div class="success" v-else-if="scope.row.formbuilder_data_status == 'COMPLETED'">
                <i class="el-icon-success"></i>
                <span class="d-inline-block pl-10">
                  {{ scope.row.formbuilder_data_status == 'COMPLETED' ? 'Completed' : '' }}
                </span>
              </div>

              <div class="expired-div" v-else-if="scope.row.formbuilder_data_status == 'EXPIRED'">
                <i class="el-icon-error"></i>
                <span class="d-inline-block pl-10">
                  {{ scope.row.formbuilder_data_status == 'EXPIRED' ? 'Expired' : '' }}
                </span>
              </div>

              <div v-else>Pending</div>
            </template>
          </el-table-column>
          <el-table-column
            label="Due Date"
            width="170"
            v-if="selectedTableFields.includes('due_date')"
          >
            <template slot-scope="scope" id="completion_status">
              {{ scope.row.expires_at | moment('MM-DD-YYYY HH:mm') }}
            </template>
          </el-table-column>
          <el-table-column prop="action" min-width="150px" fixed="right" label="Actions">
            <template slot-scope="scope" id="action">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a
                    @click="onHold(scope.row)"
                    v-if="
                      checkIsApproverUser(scope.row, false) &&
                      scope.row.approval_status == 'PENDING'
                    "
                  >
                    <el-dropdown-item icon="el-icon-video-pause" command="view">
                      {{ approvalHoldName ? approvalHoldName : 'HOLD' }}
                    </el-dropdown-item>
                  </a>
                  <a @click="onApprove(scope.row)" v-if="checkIsApproverUser(scope.row, false)">
                    <el-dropdown-item icon="el-icon-finished" command="approve">
                      Approve
                    </el-dropdown-item>
                  </a>
                  <a
                    @click="showRejectConfirm(scope.row)"
                    v-if="checkIsApproverUser(scope.row, false)"
                  >
                    <el-dropdown-item icon="el-icon-circle-close" command="reject">
                      Reject
                    </el-dropdown-item>
                  </a>
                  <a @click="viewFormbuilderData(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                  </a>
                  <a
                    @click="editWorkUserData(scope.row)"
                    style="border: none"
                    v-if="checkIsApproverUser(scope.row, true)"
                  >
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                      Edit
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      scope.row.allow_rework_on_form &&
                      scope.row.approval_status != 'APPROVED' &&
                      scope.row.approval_status != 'REJECTED' &&
                      scope.row.contact.email != getAuthenticatedUser.email
                    "
                    @click="showReworkConfirm(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-refresh" command="rework">
                      {{ getReworkLabel(scope.row) }}
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="scope.row.allow_export_as_excel"
                    @click="exportFormbuilderAsExcel(scope.row)"
                  >
                    <el-dropdown-item command="excel">
                      <i class="el-icon-upload2"></i>
                      Export as Excel
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="scope.row.allow_export_as_pdf"
                    @click="exportFormbuilderDataAsPdf(scope.row)"
                  >
                    <el-dropdown-item command="pdf">
                      <i class="fa fa-file-pdf-o"></i>
                      Export as Pdf
                    </el-dropdown-item>
                  </a>
                  <a @click="downloadDocuments(scope.row)">
                    <el-dropdown-item command="download-documents">
                      <i class="el-icon-download"></i>
                      Download Documents
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <data-tables-server
          :data="data"
          :total="total"
          :current-page.sync="currentPage"
          :page-size="pageSize"
          :pagination-props="paginationProps"
          @query-change="loadData"
          v-loading="loading"
          v-else-if="getIsMobile"
        >
          <el-table-column type="expand">
            <template slot-scope="scope">
              <div class="expand-column-item" v-if="hasIntervals">
                <div class="expand-column-item-label">Submitted For</div>
                <div class="expand-column-item-content">
                  {{ scope.row.time_interval | moment(fequencyDateMap[intervalType]) }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Sent Status</div>
                <div class="expand-column-item-content">
                  {{ scope.row.sent_at | moment('MM-DD-YYYY HH:mm') }}
                </div>
              </div>
              <div class="expand-column-item">
                <div class="expand-column-item-label">Completion Status</div>
                <div class="expand-column-item-content">
                  <div class="warning">
                    <i
                      class="el-icon-refresh"
                      v-if="
                        scope.row.formbuilder_data_status == 'PENDING' ||
                        scope.row.formbuilder_data_status == 'SENT'
                      "
                    ></i>
                    <span class="d-inline-block pl-10">
                      {{
                        scope.row.formbuilder_data_status == 'PENDING' ||
                        scope.row.formbuilder_data_status == 'SENT'
                          ? 'Pending'
                          : ''
                      }}
                    </span>
                  </div>

                  <div class="success">
                    <i
                      class="el-icon-success"
                      v-if="scope.row.formbuilder_data_status == 'COMPLETED'"
                    ></i>
                    <span class="d-inline-block pl-10">
                      {{ scope.row.formbuilder_data_status == 'COMPLETED' ? 'Completed' : '' }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column width="50" fixed="left">
            <template>
              <div>
                <img src="@/assets/img/avatar-2.svg" alt="avatar" width="30" />
              </div>
            </template>
          </el-table-column>
          <el-table-column label="User" min-width="300">
            <template slot-scope="scope">
              <div class="d-flex">
                <div>{{ getUserEmail(scope.row) }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="action" min-width="100px">
            <template slot-scope="scope">
              <el-dropdown>
                <span class="el-dropdown-link">
                  Actions
                  <i class="el-icon-caret-bottom el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <a
                    @click="onHold(scope.row)"
                    v-if="
                      checkIsApproverUser(scope.row, false) &&
                      scope.row.approval_status == 'PENDING'
                    "
                  >
                    <el-dropdown-item icon="el-icon-video-pause" command="view">
                      {{ approvalHoldName ? approvalHoldName : 'HOLD' }}
                    </el-dropdown-item>
                  </a>
                  <a @click="onApprove(scope.row)" v-if="checkIsApproverUser(scope.row)">
                    <el-dropdown-item icon="el-icon-finished" command="approve">
                      Approve
                    </el-dropdown-item>
                  </a>
                  <a @click="showRejectConfirm(scope.row)" v-if="checkIsApproverUser(scope.row)">
                    <el-dropdown-item icon="el-icon-circle-close" command="reject">
                      Reject
                    </el-dropdown-item>
                  </a>
                  <a @click="viewFormbuilderData(scope.row)" style="border: none">
                    <el-dropdown-item icon="el-icon-view" command="view">View</el-dropdown-item>
                  </a>
                  <a
                    @click="editWorkUserData(scope.row)"
                    style="border: none"
                    v-if="checkIsApproverUser(scope.row)"
                  >
                    <el-dropdown-item icon="el-icon-edit-outline" command="edit">
                      Edit
                    </el-dropdown-item>
                  </a>
                  <a
                    v-if="
                      scope.row.allow_rework_on_form &&
                      scope.row.approval_status != 'APPROVED' &&
                      scope.row.approval_status != 'REJECTED' &&
                      scope.row.contact.email != getAuthenticatedUser.email
                    "
                    @click="showReworkConfirm(scope.row)"
                    style="border: none"
                  >
                    <el-dropdown-item icon="el-icon-refresh" command="rework">
                      {{ getReworkLabel(scope.row) }}
                    </el-dropdown-item>
                  </a>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </data-tables-server>
      </div>
    </div>
    <el-pagination
      v-if="!loading"
      :class="'custom-pagination'"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="currentPage"
      :page-sizes="pageSizes"
      :page-size="pageSize"
      :pager-count="5"
      layout="prev, pager, next, jumper, sizes, total"
      :total="total"
      small
    ></el-pagination>
    <dialog-component
      :destroy-on-close="true"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerHeight="getIsMobile ? '100%' : '42%'"
      :visible.sync="reasonForRejectModal"
      title="Reason for reject"
      @before-close="reasonForRejectModalPop"
    >
      <el-input
        type="textarea"
        :rows="6"
        placeholder="Reason for reject"
        v-model="reasonForReject"
        class="p-3"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectFormbuilder(reasonForRejectData)"
          type="primary"
          :disabled="!reasonForReject.length"
        >
          Submit
        </el-button>
        <el-button @click="reasonForRejectModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showRevokeReasonDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for revoke approval"
      @before-close="closeRevokeDialog"
    >
      <div class="p-4">
        Are you sure to revoke the approval? Please mention your reason below:
        <el-input
          type="textarea"
          :rows="4"
          placeholder="Reason for revoke approval (Optional)"
          v-model="reasonForRevokeApproval"
          class="mt-1 mb-1"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="revokeApproval(reasonForRevokeApprovalData)" type="primary">
          Revoke
        </el-button>
        <el-button @click="closeRevokeDialog">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="showBulkRejectDialog"
      :containerWidth="getIsMobile ? '100%' : '40%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="Reason for rejection"
      @before-close="closeBulkRejectDialog"
    >
      <el-input
        type="textarea"
        :rows="2"
        placeholder="Reason for reject"
        v-model="reasonForBulkRejection"
        class="mt-1 mb-1"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="rejectSelctedFormData()"
          type="primary"
          :disabled="!reasonForBulkRejection.length"
        >
          Submit & Reject All
        </el-button>
        <el-button @click="closeBulkRejectDialog">Cancel</el-button>
      </span>
    </dialog-component>

    <dialog-component
      :destroy-on-close="true"
      :visible.sync="openColumnSettingsModal"
      :containerWidth="getIsMobile ? '100%' : '60%'"
      :containerMaxHeight="getIsMobile ? '100%' : '70%'"
      title="View Fields"
      @before-close="closeSettingsModal"
    >
      <div class="tree-container p-4">
        <el-tree
          class="filter-tree"
          :data="selectedColumnFields"
          :props="props"
          default-expand-all
          show-checkbox
          highlight-current
          :filter-node-method="filterNode"
          ref="tree"
          node-key="id"
          :default-checked-keys="selectedTableFields"
          @check-change="checkedNodes"
          v-if="!refresh"
        ></el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeSettingsModal()" type="primary">Apply</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      :visible.sync="reasonForReworkModal"
      :containerWidth="'55%'"
      :containerHeight="'75%'"
      title="Reason for rework"
      @before-close="reasonForReworkModaldialog"
    >
      <div
        v-loading="reworkDialogLoading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="Fetching fields, please wait..."
        class="p-3"
      >
        <div style="margin-bottom: 20px">
          <label style="font-weight: bold; display: block; margin-bottom: 5px">
            Select user type:
          </label>
          <el-select v-model="selectedReworkUserType" placeholder="Select type" style="width: 100%">
            <el-option
              v-for="(type, index) in reworkUserTypes"
              :key="index"
              :label="type.label"
              :value="type.value"
            />
          </el-select>
          <label style="font-weight: bold; display: block; margin-bottom: 5px; margin-top: 5px">
            Select user or approver:
          </label>
          <el-select
            v-if="selectedReworkUserType == 'SPECIFIC_USER'"
            v-model="selectedApproverEmail"
            placeholder="Select an approver"
            style="width: 100%"
          >
            <el-option
              v-for="(approver, index) in userAndApproversEmails"
              :key="index"
              :label="approver.label"
              :value="approver.value + (approver.levelIndex > -1 ? '#' + approver.levelIndex : '')"
            />
          </el-select>

          <el-select
            v-if="selectedReworkUserType == 'GROUP'"
            v-model="selectedApproverGroupIndex"
            placeholder="Select group"
            style="width: 100%"
          >
            <el-option
              v-for="(group, index) in approverGroups"
              :key="index"
              :label="
                'Approver Group - Level-' +
                (group.order + 1) +
                (group.filter_name ? ' - ' + group.filter_name : '')
              "
              :value="group.order"
            />
          </el-select>
        </div>

        <div>
          <label style="font-weight: bold; display: block; margin-bottom: 5px">Reason:</label>
          <CkEditorOffline v-model="reasonForRework" :config="editorConfig"></CkEditorOffline>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button
          @click="onRework(reasonForReworkData)"
          type="primary"
          :disabled="
            !reasonForRework.length || (!selectedApproverEmail && selectedApproverGroupIndex == -1)
          "
        >
          Submit
        </el-button>
        <el-button @click="reasonForReworkModaldialog">Cancel</el-button>
      </span>
    </dialog-component>
    <dialog-component
      :destroy-on-close="true"
      @before-close="reasonForApproveModaldialog"
      :visible="reasonForApproveModal"
      :title="approvalDialogTitle"
      :containerWidth="'40%'"
      :containerHeight="'42%'"
    >
      <div class="p-1 mb-2">
        <el-input
          v-if="approvalReasonDetails && approvalReasonDetails.show_approval_reason_dialog"
          type="textarea"
          :rows="6"
          placeholder="Reason for approve"
          v-model="reasonForApprove"
          class="p-3"
        ></el-input>
        <div
          class="ml-2"
          v-if="approvalReasonDetails && approvalReasonDetails.show_approval_rating"
        >
          <span>Rating</span>
          <el-rate
            v-model="approval_rating"
            class="custom-large-stars"
            show-text
            :texts="['Needs Improvement', 'Developing', 'Competent', 'Proficient', 'Expert']"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="approveFormbuilder(reasonForApproveData)"
          type="primary"
          :disabled="
            !reasonForApprove.length || (!selectedApproverEmail && selectedApproverGroupIndex == -1)
          "
        >
          Submit
        </el-button>
        <el-button @click="reasonForApproveModal = false">Cancel</el-button>
      </span>
    </dialog-component>
    <div v-if="showExportWidget">
      <templates-data-export-widget
        :key="exportWidgetKey"
        :formbuilderDetails="exportFormbuilderDetails"
        :templatesFields="[]"
        :selectedFields="[]"
        :applicationUserFilledDataIds="[exportRowData._id]"
        :fromApprovalFormView="true"
      ></templates-data-export-widget>
    </div>
    <el-drawer
      title="Advanced Approval Logs"
      :visible.sync="showFormDataLogs"
      :direction="'rtl'"
      :z-index="3000"
      :with-header="true"
      :size="getIsMobile ? '80%' : '50%'"
      :before-close="closeFormDataLogs"
    >
      <formbuilderAdvancedLogs
        :key="clickedFormbuilderData?._id"
        :currentFormbuilderData="clickedFormbuilderData"
        :formbuilderDetails="clickedFormbuilderData?.formbuilders_details_id"
      ></formbuilderAdvancedLogs>
    </el-drawer>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex';
  import config from '@/config/app';
  import moment from 'moment';
  import FormbuilderHelper from '@/mixins/FormbuilderHelper.js';
  import TemplateBuilderHelper from '@/mixins/templateBuilderHelper.js';
  import CustomDashboardHelper from '../../mixins/CustomDashboardHelper';
  import EntityHelper from '@/mixins/EntitiesHelper';
  import { postAPICall } from '@/helpers/httpHelper';
  import { ckEditorConfig } from '@/assets/data/ckeditor_config.ts';
  import axios from 'axios';
  import JSZip from 'jszip';
  export default {
    name: 'FormbuilderUsersData',
    components: {
      formbuilderAdvancedLogs: () => import('@/components/widgets/formbuilderAdvancedLogsWidget'),
      CkEditorOffline: () => import('@/components/CkEditor.vue'),
      formbuilderLogs: () => import('@/components/widgets/formbuilderLogsWidget'),
      TemplatesDataExportWidget: () => import('../widgets/templatesDataExportWidget'),
    },
    mixins: [FormbuilderHelper, TemplateBuilderHelper, CustomDashboardHelper, EntityHelper],
    data() {
      return {
        approvalReasonDetails: null,
        selectedApproverGroupIndex: null,
        approverGroups: [],
        reworkUserTypes: [
          { value: 'SPECIFIC_USER', label: 'Specific User' },
          { value: 'GROUP', label: 'Group' },
        ],
        selectedReworkUserType: 'SPECIFIC_USER',
        approval_rating: 0,
        approvalDialogTitle: 'Reason for approve',
        showFormDataLogs: false,
        clickedFormbuilderData: null,
        exportWidgetKey: 0,
        showExportWidget: false,
        exportRowData: null,
        exportFormbuilderDetails: null,
        pdfFormDetails: null,
        approvedAtFilter: '',
        approvedAtCustomDateRange: null,
        adjustedApprovedAtDateRange: null,
        rejectedAtFilter: '',
        rejectedAtCustomDateRange: null,
        adjustedRejectedAtDateRange: null,
        dateFilters: [
          { label: 'Today', value: 'today' },
          { label: 'Yesterday', value: 'yesterday' },
          { label: 'This Week', value: 'this_week' },
          { label: 'Last Week', value: 'last_week' },
          { label: 'This Month', value: 'this_month' },
          { label: 'Last Month', value: 'last_month' },
          { label: 'This Year', value: 'this_year' },
          { label: 'Last Year', value: 'last_year' },
          { label: 'Custom Date Range', value: 'custom_date_range' },
        ],
        reasonForApproveData: null,
        reasonForApprove: '',
        reasonForApproveModal: false,
        selectedApproverEmail: '',
        userAndApproversEmails: [],
        reworkDialogLoading: false,
        allMentionableFields: [],
        editorConfig: JSON.parse(JSON.stringify(ckEditorConfig)),
        detailedDataLoadingMap: {},
        clickedFormAllFields: [],
        clickedFormData: {},
        refresh: false,
        selectedTableFields: [
          'form_name',
          'user_email',
          'user_name',
          'approval_status',
          'sent_status',
          'completion_status',
          'due_date',
        ],
        props: {
          children: 'children',
          label: 'label',
          disabled: 'disabled',
        },
        selectedColumnFields: [],
        openColumnSettingsModal: false,
        haveOneFormbuilder: false,
        allFields: [],
        currentFormbuilderDetails: {},
        templateFields: [],
        templateIds: [],
        contentFields: [
          'HEADING',
          'PARAGRAPH',
          'VIDEO',
          'SINGLE_LINE_CONTENT',
          'HORIZONTAL_LINE',
          'DIVISION',
          'HTML_CONTENT',
          'ACTION_BUTTON',
          'HTML_CONTENT',
        ],
        formbuilder_code: null,
        loading: false,
        editDailogVisible: false,
        selectedOfferLetterTemplate: '',
        total: 0,
        currentPage: 1,
        pageSize: 0,
        pageSizes: [10, 20, 50, 100],
        data: [],
        addDialogVisible: false,
        previewDialogVisible: false,
        selectedOfferLetter: null,
        viewOfferLetterVisible: false,
        documentSelectDialogVisible: false,
        selectedConfigurableDocument: null,
        documentsLoading: false,
        selectedEmployee: null,
        title: '',
        firstTemplateFields: [],
        firstTemplateId: null,
        workflowIconPath: 'block-portfolio.svg',
        workFlowPublicURL: '',
        selectedUserId: '',
        hasIntervals: false,
        intervalType: '',
        fequencyDateMap: {
          DAILY: 'YYYY-DD-MM',
          WEEKLY: 'YYYY-DD-MM',
          MONTHLY: 'YYYY-DD-MM',
          YEARLY: 'YYYY-DD-MM',
          HOURLY: 'YYYY-DD-MM HH:mm',
        },
        formbuilderReciever: '',
        approver: '',
        approvedFormsData: [],
        activeTab: 'need_to_be_approved',
        needToApproveOthersCount: 0,
        holdCount: 0,
        needToApproveCount: 0,
        approvedCount: 0,
        rejectedCount: 0,
        reasonForReject: '',
        reasonForRejectModal: false,
        reasonForRejectData: null,
        reasonForReworkData: null,
        reasonForRework: '',
        reasonForReworkModal: false,
        allEntitiesData: [],
        allCompanyUserTypesData: [],
        showRevokeReasonDialog: false,
        reasonForRevokeApproval: '',
        reasonForRevokeApprovalData: null,
        loadingText: 'Fetching data, please wait...',
        approvalHoldName: 'HOLD',
        selectedRowsIds: [],
        showBulkRejectDialog: false,
        reasonForBulkRejection: '',
        selectedFilterFormbuilderids: [],
        allFormbuildersDetails: [],
        resendLoading: false,
      };
    },
    computed: {
      ...mapGetters('formBuilders', [
        'getFormBuilderAddStatus',
        'getFormBuilder',
        'getFormBuilderRemindersSettings',
        'getFormBuilderUpdateStatus',
        'getFormBuilderPublicURLDetails',
        'getApprovalFormIds',
      ]),
      ...mapGetters('formbuilderData', [
        'getFormbuilderUsersData',
        'getFormbuilderUniqueUsersData',
        'getFormbuilderCreateByContactData',
        'getFormbuilderCreateByContactStatus',
        'getFormbuilderCreateByContactErrors',
        'getFormbuilderDataDeleteStatus',
        'getFormbuilderDataDeleteError',
        'getFormbuilderDataUpdateStatus',
        'getFetchUsersApprovalFormbuilderData',
        'getFetchUsersApprovalFormbuilderCount',
        'getFormbuilderDataUpdateError',
      ]),
      ...mapGetters('templatesData', ['getTemplateFieldsData']),
      ...mapGetters('companyEntities', ['getSingleCompanyEntity']),
      ...mapGetters('contacts', ['getAllContacts']),
      ...mapGetters('navigationOpen', ['getIsMobile']),
      ...mapGetters('auth', [
        'getDefaultDateFormat',
        'getAuthenticatedUser',
        'getActiveWorkspace',
        'getUserType',
        'getUserTypeList',
      ]),
      ...mapGetters('company', ['getCompanyDetails']),
      ...mapGetters('entitiesData', ['getCreateDocumentForEntityData']),
      isCompanyOwner() {
        return this.getFormBuilder.form_builders_owner == 'COMPANY';
      },
      paginationProps() {
        return {
          pageSizes: this.pageSizes || [10, 20, 50, 100],
        };
      },
      logoUploadUrl() {
        return config.S3_BUCKET_URL;
      },
      getUserEmail() {
        return (formbuilderData) => {
          if (formbuilderData.contact) {
            return formbuilderData.contact && formbuilderData.contact.email
              ? formbuilderData.contact.email
              : '';
          }
          return '';
        };
      },
      getUserName() {
        return (formbuilderData) => {
          if (formbuilderData.contact) {
            return formbuilderData.contact &&
              formbuilderData.contact.first_name &&
              formbuilderData.contact.last_name
              ? formbuilderData.contact.first_name + ' ' + formbuilderData.contact.last_name
              : '';
          }
          return '';
        };
      },
      getContacts() {
        return this.getAllContacts && this.getAllContacts.data ? this.getAllContacts.data : [];
      },
      isApprovedForm() {
        return true;
      },
      fromAppliedFilter() {
        return this.$route?.query?.apply_filter == 'true' ? true : false;
      },
      isGenerateUniqueId() {
        return this.getCompanyDetails?.form_builder_settings?.is_generate_unique_id ? true : false;
      },
    },
    async mounted() {
      if (
        this.$route?.query?.status == 'approved' ||
        this.$route?.query?.approvalstatus == 'approved'
      ) {
        this.activeTab = 'approved';
      } else if (
        this.$route?.query?.status == 'rejected' ||
        this.$route?.query?.approvalstatus == 'rejected'
      ) {
        this.activeTab = 'rejected';
      } else if (
        this.$route?.query?.status == 'hold' ||
        this.$route?.query?.approvalstatus == 'hold'
      ) {
        this.activeTab = 'hold';
      } else {
        this.activeTab = 'need_to_be_approved';
      }
      await this.$store.commit('entitiesData/setApplyFormbuilderFilters', null, {
        root: true,
      });
      let limit = (this.pageSizes && this.pageSizes[0]) || 10;
      this.pageSize = limit;
      [this.allCompanyUserTypesData, this.allEntitiesData] = await Promise.all([
        this.fetchCompanyUsersTypes(),
        this.fetchAllEntities(),
      ]);
      await this.getNecessaryInfo();
      await this.$store.commit('formBuilders/setFormBuilderPrevRouter', null, {
        root: true,
      });
      this.configCKeditor();
    },

    methods: {
      getApproverGroups(formbuilderData) {
        let isAdvanced =
          formbuilderData?.formbuilders_details_id?.approval_configuration_type == 'ADVANCED'
            ? true
            : false;
        let currentLevelIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        let allApproverGroups = formbuilderData.formbuilders_details_id.approval_users.filter(
          (e) =>
            e.user_type == 'APPLICATION' &&
            e.individual_entity_resource == 'FILTER' &&
            e.order < currentLevelIndex
        );
        this.approverGroups = allApproverGroups;
      },
      async downloadDocuments(rowData) {
        await this.getClickedFormMentionableFields(rowData);
        let filteredDocumentFields = this.allMentionableFields.filter(
          (e) => e.input_type == 'FILE'
        );
        let documentsData = [];
        if (filteredDocumentFields?.length) {
          filteredDocumentFields.forEach((f) => {
            let keyParts = f.template_key.split('#');
            if (keyParts.length == 3) {
              let document = this.getFormbuilderFieldValue(f.template_key, rowData);
              if (document?.files?.length) {
                documentsData = [...document.files, ...documentsData];
              }
            }
          });
        }
        if (documentsData.length == 1) {
          await this.onDownloadFile(documentsData[0]);
        } else if (documentsData.length > 1) {
          //download all docs in a zip file
          await this.downloadMultipleDocsAsZip(documentsData);
        } else {
          this.$message.warning('No documents found in this form data');
        }
      },
      async onDownloadFile(data) {
        this.loading = true;
        this.loadingText = 'Downloading File....';
        let fileName = data.name;
        fileName = await fileName.replace(/\//g, '-');
        fileName = await fileName.replace(/ /g, '_');
        fileName = await fileName.replace(/[()]/g, '');
        if (data && !data.path) {
          data.path = `template-data-documents/${fileName}`;
        }
        await this.$store.dispatch('templatesData/downloadTemplateDocument', {
          path: data.path,
        });
        await fetch(this.getDownloadUrl, {
          method: 'GET',
          responseType: 'blob',
        })
          .then((res) => res.blob())
          .then((response) => {
            var fileURL = window.URL.createObjectURL(response);
            const link = document.createElement('a');
            link.href = fileURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.loading = false;
          });
        if (this.getDownloadUrl) {
          // get download url
        } else {
          this.$notify.error({
            title: 'Error',
            message: this.getDownloadError,
          });
        }
        this.loading = false;
        this.loadingText = 'Loading...';
      },
      async downloadMultipleDocsAsZip(docsData) {
        this.loading = true;
        this.loadingText = 'Downloading Zip, please wait...';
        let docUrls = [];

        for (const data of docsData) {
          let fileName = data.name;
          fileName = fileName.replace(/\//g, '-').replace(/ /g, '_').replace(/[()]/g, '');

          if (data && !data.path) {
            data.path = `template-data-documents/${fileName}`;
          }

          await this.$store.dispatch('templatesData/downloadTemplateDocument', {
            path: data.path,
          });

          if (this.getDownloadUrl) {
            docUrls.push({ url: this.getDownloadUrl, name: fileName });
          }
        }

        if (docUrls.length === 0) {
          console.log('No documents found to download.');
          return;
        }

        let zipName = docUrls[0].name || 'documents';
        await this.downloadMultipleEntityDataPdfs(docUrls, zipName);
        this.loading = false;
        this.loadingText = '';
      },
      downloadMultipleEntityDataPdfs(pdfUrls, zipName) {
        const zip = new JSZip();
        const promises = pdfUrls.map((url) =>
          axios
            .get(url.url, { responseType: 'blob' })
            .then((response) => zip.file(url.name, response.data))
        );

        Promise.all(promises)
          .then(() => {
            zip.generateAsync({ type: 'blob' }).then((blob) => {
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = `${zipName}.zip`;
              a.click();
              window.URL.revokeObjectURL(url);
            });
          })
          .catch((error) => {
            console.error('Error while downloading files:', error);
          });
      },
      openAdvancedLogs(rowData) {
        this.clickedFormbuilderData = { ...rowData };
        this.$nextTick(() => {
          this.showFormDataLogs = true;
        });
      },
      closeFormDataLogs() {
        this.showFormDataLogs = false;
        this.clickedFormbuilderData = null;
      },
      isAdvancedApproval(row) {
        return row.formbuilders_details_id.approval_configuration_type == 'ADVANCED' ? true : false;
      },
      formatFormNameWithLabels(row) {
        const customization = row.formbuilders_details_id.customization;
        if (!customization || !customization.isFormLabel) return '';

        const separator = customization.separator || ' ';
        const selectedFields = customization.selected_fields || [];
        const values = selectedFields
          .map((fieldPath) => {
            const fieldObj = this.allFields.find((f) => f.data_key === fieldPath);
            if (!fieldObj) return '';
            return this.getFormbuilderFieldValue(fieldObj.data_key, row) || '';
          })
          .map((v) => String(v).trim())
          .filter((v) => v !== '');
        if (values.length === 0) return '';

        return ` ${separator} ${values.join(separator)}`;
      },
      async exportFormbuilderAsExcel(formData) {
        this.showExportWidget = false;
        this.exportRowData = null;
        this.exportFormbuilderDetails = null;
        this.exportRowData = { ...formData };
        await this.$store.dispatch('formBuilders/fetchFormBuilder', {
          id: formData.formbuilders_details_id._id,
          include_template_details: true,
          include_entity_details: true,
          include_documents_details: true,
        });
        this.exportFormbuilderDetails = JSON.parse(JSON.stringify(this.getFormBuilder));
        this.$nextTick(() => {
          this.exportWidgetKey++;
          this.showExportWidget = true;
        });
      },
      async exportFormbuilderDataAsPdf(data) {
        this.pdfFormDetails = null;
        let entityStep = data.formbuilder_steps_data.find(
          (s) => s.type == 'ENTITY' && s.entity_id && s.entity_data_id
        );
        await this.$store.dispatch('formBuilders/fetchFormBuilder', {
          id: data.formbuilders_details_id._id,
          include_template_details: true,
          include_entity_details: true,
          include_documents_details: true,
        });
        this.pdfFormDetails = JSON.parse(JSON.stringify(this.getFormBuilder));
        let entityDetails = this.pdfFormDetails?.steps.find(
          (s) => s.type == 'ENTITY' && s.entity._id == entityStep.entity_id
        );
        if (entityDetails?.entity?.default_printing_document && entityStep?.entity_data_id) {
          this.printEntityDataOnDocument(entityDetails.entity, entityStep.entity_data_id);
        } else {
          return this.$message.warning('Please generate a document template in the entity!');
        }
      },
      async printEntityDataOnDocument(entityInfo, entityDataId) {
        this.loading = true;
        this.loadingText = 'Downloading pdf, please wait...';

        await this.$store.dispatch('entitiesData/createDocumentFromEntityData', {
          entity_data_id: entityDataId,
          entity_id: entityInfo._id,
          document_id: entityInfo.default_printing_document || '',
          custom_message: entityInfo?.pdf_printing_info?.custom_message || '',
        });

        if (
          this.getCreateDocumentForEntityData &&
          this.getCreateDocumentForEntityData.generatedDocuments
        ) {
          this.loading = false;
          this.loadingText = '';

          this.downloadEntityDataPdf(
            this.getCreateDocumentForEntityData.generatedDocuments,
            this.getCreateDocumentForEntityData?.doc_printing_names.length &&
              this.getCreateDocumentForEntityData.doc_printing_names[0]
              ? this.getCreateDocumentForEntityData.doc_printing_names[0].trim()
              : entityInfo && entityInfo.name
                ? entityInfo.name
                : 'Data '
          );
        } else {
          this.loadingText = '';
          this.loading = false;

          this.$message({
            message: 'Error while generating document',
            type: 'error',
          });
        }
      },
      async onApprovedAtChange() {
        if (this.approvedAtFilter !== 'custom_date_range') {
          this.approvedAtCustomDateRange = null;
          await this.fetchAllEmployee();
        }
      },
      async onRejectedAtChange() {
        if (this.rejectedAtFilter !== 'custom_date_range') {
          this.rejectedAtCustomDateRange = null;
          await this.fetchAllEmployee();
        }
      },
      onApprovedAtDateRangeChange() {
        if (this.approvedAtCustomDateRange && this.approvedAtFilter === 'custom_date_range') {
          const startDate = this.approvedAtCustomDateRange[0];
          let endDate = new Date(this.approvedAtCustomDateRange[1]);
          endDate.setDate(endDate.getDate() + 1);
          this.adjustedApprovedAtDateRange = [startDate, endDate];
          this.fetchAllEmployee();
        }
      },
      onRejectedAtDateRangeChange() {
        if (this.rejectedAtCustomDateRange && this.rejectedAtFilter === 'custom_date_range') {
          const startDate = this.rejectedAtCustomDateRange[0];
          let endDate = new Date(this.rejectedAtCustomDateRange[1]);
          endDate.setDate(endDate.getDate() + 1);
          this.adjustedRejectedAtDateRange = [startDate, endDate];
          this.fetchAllEmployee();
        }
      },
      reasonForApproveModaldialog() {
        this.reasonForApproveModal = false;
      },
      checkRevokePermission(status, data) {
        let currentuserIndex = this.getCurrentApprover(data);
        let isAllowed = false;
        if (currentuserIndex > -1) {
          // Yes approver
          if (status == 'approved') {
            isAllowed = data.allow_revoke_for_approved || data.allow_revoke_for_both;
          } else if (status == 'rejected') {
            isAllowed = data.allow_revoke_for_rejected || data.allow_revoke_for_both;
          }
        } else {
          //Not approver means filler
          if (status == 'approved') {
            isAllowed =
              data.allow_revoke_for_approved_for_filler || data.allow_revoke_for_both_for_filler;
          } else if (status == 'rejected') {
            isAllowed =
              data.allow_revoke_for_rejected_for_filler || data.allow_revoke_for_both_for_filler;
          }
        }
        return isAllowed;
      },
      async getApprovers(data) {
        this.userAndApproversEmails = [];
        let userEmailEntry = {
          label: `USER - ${data?.contact?.email}`,
          value: `user#${data?.contact?.email}`,
          is_approver: false,
        };
        const url = '/formbuilder-data/fetch-approvers';
        let params = {
          formbuilder_data: data,
          approvers: data.formbuilders_details_id.approval_users,
          include_user_contact: typeof data?.contact == 'string' ? data.contact : false,
        };
        let response = await postAPICall('POST', url, params);
        this.userAndApproversEmails = [userEmailEntry, ...(response.approver_emails || [])];
        if (!data?.formbuilders_details_id?.enforce_order) {
          this.userAndApproversEmails = this.userAndApproversEmails.filter(
            (usr) => usr.email !== this.getAuthenticatedUser.email
          );
        }
        let isAdvanced =
          data?.formbuilders_details_id?.approval_configuration_type == 'ADVANCED' ? true : false;
        if (data?.formbuilders_details_id?.enforce_order) {
          let currentLevelIndex = this.getCurrentApprover(data, isAdvanced);
          let filteredApprovers = this.userAndApproversEmails.filter((approver) => {
            if (approver?.value?.includes('user#')) {
              return true;
            }
            return approver.levelIndex < currentLevelIndex;
          });
          this.userAndApproversEmails = filteredApprovers;
          this.userAndApproversEmails = this.userAndApproversEmails.map((e) =>
            e.value.includes('user#')
              ? e
              : {
                  ...e,
                  label:
                    e.label.split(' - ')[0] +
                    ' - ' +
                    ' Level-' +
                    (e.levelIndex + 1) +
                    ' - ' +
                    e.label.split(' - ')[1],
                }
          );
        }
      },
      async updateStatus() {
        if (
          this.$route?.query?.status == 'approved' ||
          this.$route?.query?.approvalstatus == 'approved'
        ) {
          this.activeTab = 'approved';
        } else if (
          this.$route?.query?.status == 'rejected' ||
          this.$route?.query?.approvalstatus == 'rejected'
        ) {
          this.activeTab = 'rejected';
        } else if (
          this.$route?.query?.status == 'hold' ||
          this.$route?.query?.approvalstatus == 'hold'
        ) {
          this.activeTab = 'hold';
        } else {
          this.activeTab = 'need_to_be_approved';
        }
      },
      async getClickedFormMentionableFields(formbuilderData) {
        try {
          this.reworkDialogLoading = true;
          const formbuilder_id = formbuilderData?.formbuilders_details_id?._id;
          const stepsDataUrl = `/formBuilders/all-fields/${formbuilder_id}`;
          const response = await postAPICall('GET', stepsDataUrl);
          this.allMentionableFields = [];
          response.steps_data.forEach((step) => {
            if (step.type == 'ENTITY' && Array.isArray(step.templates)) {
              step.templates.forEach((temp) => {
                const mentionableFields = temp.fields.map((e) => {
                  return {
                    ...e,
                    mention_key: `${step.entity}#${temp.template_id}#${e.key}`,
                    label: `${step.entity_name}-${temp.template_name}-${e.label}`,
                    template_key: `${step.entity}#${temp.template_id}#${e.key}`,
                  };
                });
                this.allMentionableFields.push(...mentionableFields);
              });
            }

            if (step.type == 'TEMPLATE') {
              const mentionableFields = step.fields.map((e) => {
                return {
                  ...e,
                  mention_key: `${step.template}#${e.key}`,
                  label: `${step.template_name}-${e.label}`,
                  template_key: `${step.template}#${e.key}`,
                };
              });
              this.allMentionableFields.push(...mentionableFields);
            }
          });
          if (this.allMentionableFields?.length) {
            this.allMentionableFields = this.allMentionableFields.map((item) => {
              return {
                label: item.label,
                template_key: item.template_key,
                id: item.mention_key,
                input_type: item.inputType,
              };
            });
          }
          this.configCKeditor();
          this.reasonForRework = this.mapMailTemplatevariables(this.reasonForRework);
        } catch (error) {
          console.error('Error in getClickedFormMentionableFields:', error);
        } finally {
          this.reworkDialogLoading = false;
        }
      },
      configCKeditor() {
        this.editorConfig.mentions = [
          {
            feed: this.dataFeed,
            itemTemplate:
              '<li data-id="{id}">' + '<strong class="label">{label}</strong>' + '</li>',
            outputTemplate: '<span>&nbsp;</span><span>[[{label}]]</span><span>&nbsp;</span>',
            minChars: 0,
            convertTo: function (item) {
              return {
                template_key: item.label,
              };
            },
          },
          {
            feed: '/tags?name={encodedQuery}',
            marker: '#',
          },
        ];
        this.editorConfig.id = 'rework_reason_template';
      },
      dataFeed(opts, callback) {
        var matchProperty = 'label',
          data = this.allMentionableFields.filter(function (item) {
            return item[matchProperty].toLowerCase().indexOf(opts.query.toLowerCase()) !== -1;
          });
        data = data.sort(function (a, b) {
          return a[matchProperty].localeCompare(b[matchProperty], undefined, {
            sensitivity: 'accent',
          });
        });
        callback(data);
      },
      mapMailTemplatevariables(body, revert) {
        const childRegex = /\[\[(.*?)\]\]/g;
        const childVariables = [];
        let match;
        while ((match = childRegex.exec(body)) !== null) {
          childVariables.push(match[1]);
        }
        // Replace labels with their corresponding template_keys (need to change for other entities labels)
        body = body.replace(/\[\[(.*?)\]\]/g, (match, label) => {
          const template = this.allMentionableFields.find(
            (obj) => (!revert && obj.label === label) || (revert && obj.id == label)
          );
          let value = '';
          if (revert) {
            value = template?.label;
          } else {
            value = template?.template_key;
          }
          if (template?.input_type == 'PAY_BUTTON') {
            return template ? `[[${value}#pay]]` : match;
          }
          return template ? `[[${value}]]` : match;
        });
        return body;
      },
      getReworkLabel(row) {
        return row?.customization?.rework_button_name
          ? row.customization.rework_button_name
          : 'Rework';
      },
      reasonForReworkModaldialog() {
        this.reasonForReworkModal = false;
        this.selectedReworkUserType = '';
        this.selectedApproverGroupIndex = -1;
      },
      showReworkConfirm(formbuilderData) {
        if (
          formbuilderData.approval_status == 'HOLD' &&
          formbuilderData?.current_dependent_formbuilderdata?._id &&
          formbuilderData?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = formbuilderData?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        this.reasonForReworkData = null;
        this.reasonForRework = '';
        this.reasonForReworkModal = true;
        this.reasonForReworkData = { ...formbuilderData };
        this.getClickedFormMentionableFields(formbuilderData);
        this.getApprovers(formbuilderData);
        this.getApproverGroups(formbuilderData);
      },
      async onRework(formbuilderData) {
        this.reasonForReworkModal = false;
        this.resendLoading = true;
        this.loadingText = 'Sending the form, please wait...';
        this.reasonForRework = this.mapMailTemplatevariables(this.reasonForRework, false);
        let approverGroupData = {};
        let isApproverGroup = false;
        if (this.selectedReworkUserType == 'GROUP' && this.selectedApproverGroupIndex > -1) {
          isApproverGroup = true;
          approverGroupData = formbuilderData.approval_users[this.selectedApproverGroupIndex];
          approverGroupData.mappedGroupApprovers = this.userAndApproversEmails.map((e) => ({
            ...e,
          }));
        }
        let params = {
          formbuilder_data_id: formbuilderData._id,
          formbuilders_details_id: formbuilderData.formbuilders_details_id._id,
          company_id: formbuilderData.company,
          rework_reason: this.reasonForRework,
          is_approver:
            this.selectedApproverEmail.includes('approver#') || isApproverGroup ? true : false,
          approver_data:
            this.selectedApproverEmail.includes('approver#') || isApproverGroup
              ? this.userAndApproversEmails.find(
                  (e) =>
                    e.value ==
                      this.selectedApproverEmail.split('#')[0] +
                        '#' +
                        this.selectedApproverEmail.split('#')[1] &&
                    e.levelIndex == Number(this.selectedApproverEmail.split('#')[2])
                )
              : this.userAndApproversEmails.find((e) => e.value == this.selectedApproverEmail),
          isApproverGroup: isApproverGroup,
          approverGroupData: approverGroupData,
        };
        try {
          let response = await postAPICall('POST', '/formbuilder-data/rework-form', params);
          if (response.success && response.data) {
            this.$notify.success({
              title: 'Success',
              message: 'Form sent to user email!',
            });
          }
          this.fetchAllEmployee();
          this.resendLoading = false;
          this.loadingText = '';
        } catch (err) {
          console.log('error while sending the form :', err);
        }
      },
      chunkFields(fields, size) {
        fields = fields.filter((e) => {
          const isEntityTable = e.input_type === 'ENTITY_TABLE' || e.input_type === 'DATA_TABLE';

          const isEntityVariableTable =
            e.input_type === 'ENTITY_VARIABLE' &&
            (e.inputType === 'ENTITY_TABLE' || e.inputType === 'DATA_TABLE');

          return (
            this.contentFields.indexOf(e.input_type) === -1 &&
            !isEntityTable &&
            !isEntityVariableTable &&
            e?.properties?.filed_content !== 'Hide'
          );
        });
        let chunks = [];
        for (let i = 0; i < fields.length; i += size) {
          chunks.push(fields.slice(i, i + size));
        }
        return chunks;
      },
      async fetchFormbuilderData(formData) {
        if (formData?.steps_fields_data?.length && (formData.entityData || formData.templateData)) {
          return;
        }
        this.$set(this.detailedDataLoadingMap, formData._id, true);
        const formbuilder_id = formData.formbuilders_details_id._id;
        const formbuilder_data_id = formData._id;
        const detailedDataUrl = `/formbuilder-detailed-data/${formbuilder_id}/${formbuilder_data_id}`;
        const stepsDataUrl = `/formBuilders/all-fields/${formbuilder_id}`;

        try {
          const [response, allStepsDataResponse] = await Promise.all([
            postAPICall('GET', detailedDataUrl),
            postAPICall('GET', stepsDataUrl),
          ]);
          this.clickedFormAllFields = allStepsDataResponse?.steps_data;
          this.clickedFormData = response?.data;
          const foundData = this.data.find((e) => this.clickedFormData._id == e._id);
          let entityTemplateFieldsMap = {};
          let templateFieldsMap = {};

          this.clickedFormData?.formbuilder_steps_data.forEach((step) => {
            if (
              step.type == 'ENTITY' &&
              step?.entity_id &&
              step?.entity_data_id?.templates_fields_data
            ) {
              entityTemplateFieldsMap[step.entity_id] = step.entity_data_id.templates_fields_data;
            }

            if (
              step.type == 'TEMPLATE' &&
              step?.template_id &&
              step?.template_data_id?.template_data
            ) {
              templateFieldsMap[step.template_id] = step.template_data_id.template_data;
            }
          });

          if (foundData) {
            foundData.entityData = entityTemplateFieldsMap || {};
            foundData.templateData = templateFieldsMap || {};
            foundData.steps_fields_data = this.clickedFormAllFields || [];
          }
          this.$set(this.detailedDataLoadingMap, formData._id, false);
        } catch (error) {
          this.$set(this.detailedDataLoadingMap, formData._id, false);
          console.error('Error fetching form builder data:', error);
        }
      },
      getValueByKey(row, field) {
        let keys = field.data_key.split('#');
        let fieldKey;
        let allData = {};
        if (keys.length == 3 && row?.entityData) {
          fieldKey = keys[1] + '#' + keys[2];
          allData = row.entityData;
        } else {
          fieldKey = keys[1];
          allData = row.templateData;
        }
        let value = allData?.[keys[0]]?.[fieldKey];
        if (
          field.input_type == 'LIST' ||
          (field.input_type == 'ENTITY_VARIABLE' && field.inputType == 'LIST')
        ) {
          value = field.list_data.find((e) => e.value === value)?.name || '-';
        } else if (field.input_type == 'ENTITY') {
          value = allData[keys[0]][fieldKey + '/name'];
        } else if (field.inputType == 'DATE_TIME') {
          value = moment(new Date(value)).format('MM-DD-YYYY HH:mm:ss');
        } else if (field.inputType == 'FILE') {
          value = value?.name;
        } else if (
          field.input_type == 'DATE' ||
          (field.input_type == 'ENTITY_VARIABLE' && field.inputType == 'DATE')
        ) {
          if (value) {
            value = moment(new Date(value)).format(
              this.getDefaultDateFormat && this.getDefaultDateFormat.includes('Do') == false
                ? this.getDefaultDateFormat
                : 'MM-DD-YYYY'
            );
          } else {
            value = '-';
          }
        } else if (field.input_type == 'CURRENCY') {
          value = this.getCurrencyFormatValue(field, value);
        } else if (field.input_type == 'FORMULA' && field.result_type == 'DATE') {
          let format = '';
          if (this.getDefaultDateFormat && !this.getDefaultDateFormat.includes('Do')) {
            format = this.getDefaultDateFormat || 'MM-DD-YYYY';
          }
          if (this.isDateTime(field)) {
            format += ' HH:mm:ss';
          }
          value = moment(new Date(value)).format(format);
        } else if (field.input_type == 'AGGREGATE_FUNCTION') {
          let findCurrencyField = field?.selected_fields.find((e) => e.result_type == 'CURRENCY');
          value = findCurrencyField ? this.getAggregateCurrencyFormat(value, field) : value;
        } else if (field.inputType == 'SIGNATURE') {
          if (value && !value.startsWith('data:image')) {
            value = `data:image/png;base64,${value}`;
          }
        } else if (field.input_type == 'ENTITY_VARIABLE') {
          value = allData[keys[0]][fieldKey + '/name']
            ? allData[keys[0]][fieldKey + '/name']
            : value;

          value = Array.isArray(value) ? value.join(',') : value;
        }
        value = Array.isArray(value) ? value.join(',') : value;
        return value;
      },
      checkedNodes() {
        let checked = this.$refs.tree.getCheckedNodes();
        this.selectedTableFields = checked.map((e) => e.id);
      },
      filterNode(value, data) {
        if (!value) return true;
        return data.label.toLowerCase().indexOf(value.toLowerCase()) !== -1;
      },
      openSettingsModal() {
        this.openColumnSettingsModal = true;
      },
      async closeSettingsModal() {
        this.openColumnSettingsModal = false;
        this.loading = true;
        let formDetails = this.getFormBuilder;
        formDetails.column_settings = this.selectedTableFields;
        delete formDetails.user_type;
        formDetails?.steps.forEach((step) => {
          if (step.type == 'ENTITY') {
            step.entity = step.entity?._id || step.entity;
          }
          if (step.type == 'TEMPLATE') {
            step.template = step.template._id;
          }
        });
        try {
          let response = await postAPICall(
            'PUT',
            '/formBuilders',
            JSON.parse(JSON.stringify(formDetails))
          );
          console.log('Repsonse after updating formbuilder', response);
          this.loading = false;
        } catch (err) {
          this.loading = false;
          console.log('Error while updating formbuilder', err);
        }
      },
      getTruncatedLabel(label) {
        if (
          label?.split(' - ')?.length == 3 &&
          this.currentFormbuilderDetails &&
          this.currentFormbuilderDetails?.steps?.length == 1
        ) {
          label = label.split(' - ')[2];
        }
        return label;
      },
      handleSelectionChange(checkedRows) {
        this.selectedRowsIds = checkedRows;
      },
      async approveAllChecked() {
        this.$confirm('Are you sure to approve the selected form responses?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.approveSelectedFormData();
        });
      },
      //Bulk Approve form responses
      async approveSelectedFormData() {
        this.loading = true;
        this.loadingText = 'Approving the form responses, please wait...';
        let params = [];
        this.selectedRowsIds.forEach((item, i) => {
          if (
            item &&
            item._id &&
            (item.approval_status == 'PENDING' || item.approval_status == 'HOLD')
          ) {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              let approvalData = this.getApprovalParams(item, currentuserIndex);
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Form responses approved successfully',
            });
            this.fetchAllEmployee();
          }
        }
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      showBulkRejectConfirm() {
        this.showBulkRejectDialog = true;
        this.reasonForBulkRejection = '';
      },
      closeBulkRejectDialog() {
        this.showBulkRejectDialog = false;
        this.reasonForBulkRejection = '';
      },
      //Bulk reject form responses
      async rejectSelctedFormData() {
        this.loading = true;
        this.loadingText = 'Rejecting the form responses, please wait...';
        let params = [];
        this.selectedRowsIds.forEach((item, i) => {
          if (
            item &&
            item._id &&
            (item.approval_status == 'PENDING' || item.approval_status == 'HOLD')
          ) {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              let approvalData = this.getRejectParams(
                item,
                currentuserIndex,
                this.reasonForBulkRejection
              );
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: 'Form responses rejected successfully',
            });
            this.fetchAllEmployee();
          }
        }
        this.closeBulkRejectDialog();
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      async holdAllChecked() {
        this.$confirm('Are you sure to hold the selected form responses?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.holdSelctedFormData();
        });
      },
      async holdSelctedFormData() {
        this.loading = true;
        this.loadingText = 'Holding the form responses, please wait...';
        let params = [];
        let approvalData = {
          approval_status: 'HOLD',
        };
        this.selectedRowsIds.forEach((item, i) => {
          if (item && item._id && item.approval_status == 'PENDING') {
            let currentuserIndex = this.getCurrentApprover(item);
            if (currentuserIndex > -1) {
              params.push({
                id: item._id,
                approval_data: approvalData,
              });
            }
          } else {
            i = i + 1;
            if (i == this.selectedRowsIds.length) {
              this.$message({
                message: `${i} form(s) are already ${item.approval_status}`,
                type: 'warning',
              });
            }
            this.loading = false;
          }
        });
        if (params.length) {
          const response = await postAPICall(
            'POST',
            '/formbuilder-data/bulk-approval-actions',
            params
          );
          if (response.success) {
            this.$notify.success({
              title: 'Success',
              message: `Form responses ${this.approvalHoldName} successfully`,
            });
            this.fetchAllEmployee();
          }
        }
        this.loading = false;
        this.loadingText = 'Fetching data, please wait...';
      },
      showRevokeApprovalConfirm(formbuilderData) {
        this.reasonForRevokeApprovalData = null;
        this.reasonForRevokeApproval = '';
        this.reasonForRevokeApprovalData = { ...formbuilderData };
        if (formbuilderData?.show_revoke_reason_dialog) {
          this.showRevokeReasonDialog = true;
        } else {
          this.$confirm('Are you sure to revoke the approval?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.revokeApproval(this.reasonForRevokeApprovalData);
          });
        }
      },
      closeRevokeDialog() {
        this.showRevokeReasonDialog = false;
      },
      async revokeApproval(data) {
        try {
          this.showRevokeReasonDialog = false;
          this.loading = true;
          this.loadingText = 'Revoking approval, please wait...';
          if (
            data?.allow_revoke_approval &&
            ['APPROVED', 'REJECTED'].includes(data.approval_status)
          ) {
            const response = await postAPICall('POST', '/formbuilder-data/revoke-approval', {
              formbuilder_details_id: data.formbuilders_details_id,
              formbuilder_data_id: data._id,
              revoke_reason: this.reasonForRevokeApproval,
              revoked_by:
                this.getAuthenticatedUser?.first_name +
                ' ' +
                this.getAuthenticatedUser?.last_name +
                '#' +
                this.getAuthenticatedUser?.email,
            });
            if (response) {
              this.$notify.success({
                title: 'Success',
                message: 'Approval revoked successfully',
              });
              this.fetchAllEmployee();
              this.loading = false;
            }
            this.loading = false;
            this.loadingText = '';
            this.reasonForRevokeApprovalData = null;
            this.reasonForRevokeApproval = '';
          }
        } catch (err) {
          console.log('error while revoking approval', err);
        }
      },
      async onHold(row) {
        this.$confirm('Are you sure to hold the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.holdFormbuilder(row);
        });
      },
      reasonForRejectModalPop() {
        this.reasonForRejectModal = false;
      },
      async holdFormbuilder(formbuilderData) {
        this.loading = true;
        let currentuserIndex = this.getCurrentApprover(formbuilderData);
        if (currentuserIndex > -1) {
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', {
            approval_status: 'HOLD',
            id: formbuilderData._id,
          });
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: `Form state updated to ${this.approvalHoldName} successfully!`,
              type: 'success',
            });
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message:
                this.getFormbuilderDataUpdateError.message ||
                'Error while Form state updated to hold',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loading = false;
      },
      convertToLocalDateTime(dateTime) {
        const date = new Date(dateTime);
        return date.toLocaleString();
      },
      isAnonymousForm(formbuilderData) {
        return formbuilderData?.formbuilders_details_id?.form_builders_owner === 'ANONYMOUS';
      },
      getApprovedUser(formbuilderData) {
        // In priority based approvals, only main approver details should be displayed
        if (formbuilderData?.approval_users && formbuilderData?.priority_based) {
          return formbuilderData?.approval_users.find(
            (e) =>
              (!formbuilderData.priority_based && e.approved_status) ||
              (formbuilderData.priority_based && e.approved_status && e.final_approver)
          );
        } else {
          // In non-priority based(all users need to approve) approvals, all approvers details should be displayed, so returning all the approvers
          return formbuilderData?.approval_users;
        }
      },
      getRejectedUser(formbuilderData) {
        if (formbuilderData?.approval_users) {
          return formbuilderData?.approval_users.find(
            (e) =>
              (!formbuilderData.priority_based && e.rejected_status) ||
              (formbuilderData.priority_based && e.rejected_status && e.final_approver)
          );
        }
        return null;
      },
      checkIsApproverUser(formbuilderData, isEdit) {
        let isAdvanced =
          formbuilderData?.formbuilders_details_id?.approval_configuration_type == 'ADVANCED'
            ? true
            : false;
        let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        if (
          (formbuilderData?.advanced_approval_users?.length || formbuilderData?.approval_users) &&
          formbuilderData?.approval_status != 'APPROVED' &&
          formbuilderData?.approval_status != 'REJECTED' &&
          !isEdit
        ) {
          if (isAdvanced) {
            let advApprovers = formbuilderData?.advanced_approval_users.find(
              (e) => e.current_level_index == currentuserIndex
            );
            let advancedApprover = advApprovers?.approval_users?.find(
              (e) => e.contact_id == this.getAuthenticatedUser._id
            );
            return (
              advancedApprover?.approval_status == 'PENDING' &&
              formbuilderData.formbuilder_data_status == 'COMPLETED'
            );
          }
          if (
            currentuserIndex > -1 &&
            !formbuilderData.approval_users[currentuserIndex].approved_status &&
            !formbuilderData.approval_users[currentuserIndex].rejected_status
          ) {
            return formbuilderData.formbuilder_data_status == 'COMPLETED';
          }
        }
        if (
          currentuserIndex > -1 &&
          !formbuilderData?.formbuilders_details_id?.allow_edit_for_approver
        ) {
          return false;
        }
        if (
          isEdit &&
          (formbuilderData?.approval_status == 'APPROVED' ||
            formbuilderData?.approval_status == 'REJECTED')
        ) {
          if (formbuilderData?.formbuilders_details_id?.approval_receiver_permissions) {
            let permissions =
              formbuilderData?.formbuilders_details_id?.approval_receiver_permissions;
            if (permissions?.edit == true) {
              return true;
            }
          }
        }
        if (isEdit && formbuilderData?.formbuilders_details_id?.allow_edit_for_approver) {
          return true;
        }
        return false;
      },
      async onApprove(row) {
        this.approvalReasonDetails = row?.formbuilders_details_id;
        if (
          row.approval_status == 'HOLD' &&
          row?.current_dependent_formbuilderdata?._id &&
          row?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = row?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        let field_level_permissions = row.formbuilders_details_id?.field_level_permissions;
        if (field_level_permissions && Object.keys(field_level_permissions).length > 0) {
          let isAdvanced =
            row.formbuilders_details_id?.approval_configuration_type == 'ADVANCED' ? true : false;
          const currentApproverLevel = this.getCurrentApprover(row, isAdvanced);
          await this.fetchFormbuilderData(row);
          let allFields = this.clickedFormAllFields.flatMap((item) => {
            if (item.type === 'TEMPLATE') {
              return item.fields || [];
            } else if (item.type === 'ENTITY') {
              return item.templates?.flatMap((template) => template.fields) || [];
            }
            return [];
          });
          let { allFields: allCustomizedFields } = await this.getMatchedTemplateFields(
            row.formbuilders_details_id,
            '',
            currentApproverLevel,
            isAdvanced
          );
          let allCustomizedFormBuilderFields = this.applyCustomizationOnFields(
            allFields,
            allCustomizedFields
          );
          let currentFormbuilderData = this.data.find((e) => e._id === row._id);
          let missingFieldMsg = this.validateRequiredFields(
            currentFormbuilderData?.entityData,
            allCustomizedFormBuilderFields
          );
          if (missingFieldMsg) {
            this.$notify.warning({
              title: 'Missing Required Field',
              message: missingFieldMsg,
            });
            return;
          }
        }
        if (row?.approval_redirection) {
          return this.redirect(row.approval_redirection, row);
        }
        if (row?.show_approval_reason_dialog && row?.show_approval_rating) {
          this.reasonForApproveData = null;
          this.reasonForApprove = '';
          this.reasonForApproveModal = true;
          this.reasonForApproveData = { ...row };
          this.approval_rating = null;
          this.approvalDialogTitle = 'Approval Rating & Reason';
        } else if (row?.show_approval_reason_dialog) {
          this.approvalDialogTitle = 'Approval Reason';
          this.reasonForApprove = '';
          this.reasonForApproveModal = true;
          this.reasonForApproveData = { ...row };
        } else if (row?.show_approval_rating) {
          this.approval_rating = null;
          this.approvalDialogTitle = 'Approval Rating';
          this.reasonForApproveModal = true;
        } else {
          this.$confirm('Are you sure about approving the response?', 'Warning', {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }).then(() => {
            this.approveFormbuilder(row);
          });
        }
      },
      async redirect(entityId, row) {
        if (entityId) {
          if (row?.formbuilders_details_id?.approval_redirection_filter) {
            let data = {};
            let entity_data_ids = row.formbuilder_steps_data
              .filter((e) => e.entity_data_id)
              .flatMap((e) => e.entity_data_id);
            let templates_data_ids = row.formbuilder_steps_data
              .filter((e) => e.template_data_id)
              .flatMap((e) => e.template_data_id);
            if (entity_data_ids.length) {
              let response = await postAPICall('GET', '/templates-data', {
                entity_data_ids: entity_data_ids,
              });
              (response?.data || []).forEach((d) => {
                if (data[d.entity_id]) {
                  data = {
                    ...data,
                    ...{
                      [d.template_id]: d.template_data,
                    },
                  };
                } else {
                  data[d.entity_id] = {
                    [d.template_id]: d.template_data,
                  };
                }
              });
            }

            if (templates_data_ids.length) {
              let response = await postAPICall('GET', '/templates-data', {
                template_data_ids: templates_data_ids,
              });
              console.log('response', response);
            }
            let newFilters = (
              row.formbuilders_details_id.approval_redirection_filter?.filters || []
            ).map((filter) => {
              if (filter?.value_field && filter.value_field.includes('#')) {
                let [e, t, f] = filter.value_field.split('#');
                if (data?.[e]?.[t]?.[f]) {
                  filter.value = data[e][t][f];
                }
              }
              return filter;
            });
            console.log('newFilters', newFilters);
            let key = Math.floor(Math.random() * 100000);
            await this.$store.commit(
              'entitiesData/setApplyFormbuilderFilters',
              { [key]: newFilters },
              {
                root: true,
              }
            );
            console.log('==', data);
            this.$router.push({
              path: `/entity/${entityId}?key=${key}&viewType=HTML_CONTENT`,
              query: {
                fromApprovalForms: true,
                formbuilder_id: row?.formbuilders_details_id._id,
                formbuilder_data_id: row._id,
              },
            });
          } else {
            this.$router.push({
              path: `/entity/${entityId}?key=${Math.floor(
                Math.random() * 100000
              )}&viewType=HTML_CONTENT`,
              query: {
                fromApprovalForms: true,
                formbuilder_id: row?.formbuilders_details_id?._id,
                formbuilder_data_id: row._id,
              },
            });
          }
        }
      },
      async onReject(row) {
        this.$confirm('Are you sure to reject the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.rejectFormbuilder(row);
        });
      },
      async approveFormbuilder(formbuilderData) {
        this.reasonForApproveModal = false;
        this.loading = true;
        this.loadingText = 'Approving the form, please wait...';
        let isAdvanced =
          formbuilderData?.formbuilders_details_id?.approval_configuration_type == 'ADVANCED'
            ? true
            : false;
        let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        if (currentuserIndex > -1) {
          let params = this.getApprovalParams(
            formbuilderData,
            currentuserIndex,
            this.reasonForApprove,
            isAdvanced
          );
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', params);
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: 'Approved successfully!',
              type: 'success',
            });
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message: this.getFormbuilderDataUpdateError.message || 'Error while approving',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loadingText = '';
        this.loading = false;
      },
      showRejectConfirm(formbuilderData) {
        if (
          formbuilderData.approval_status == 'HOLD' &&
          formbuilderData?.current_dependent_formbuilderdata?._id &&
          formbuilderData?.current_dependent_formbuilderdata?.formbuilders_details_id
        ) {
          let formName = formbuilderData?.current_dependent_formbuilderdata?.name || 'form';
          let msg = `This form is temporarily on hold until ${formName} has been approved. Currently waiting for ${formName} approval.`;
          return this.$notify.warning({
            title: 'Warning',
            message: msg,
          });
        }
        this.reasonForRejectData = null;
        this.reasonForReject = '';
        this.reasonForRejectModal = true;
        this.reasonForRejectData = { ...formbuilderData };
      },
      async rejectFormbuilder(formbuilderData) {
        this.loading = true;
        this.reasonForRejectModal = false;
        this.loadingText = 'Rejecting the form, please wait...';
        let isAdvanced =
          formbuilderData?.formbuilders_details_id?.approval_configuration_type == 'ADVANCED'
            ? true
            : false;
        let currentuserIndex = this.getCurrentApprover(formbuilderData, isAdvanced);
        if (currentuserIndex > -1) {
          let params = this.getRejectParams(
            formbuilderData,
            currentuserIndex,
            this.reasonForReject,
            isAdvanced
          );
          await this.$store.dispatch('formbuilderData/updateFormbuilderData', params);
          if (this.getFormbuilderDataUpdateStatus) {
            this.$message({
              message: 'Rejected successfully!',
              type: 'success',
            });
            this.reasonForRejectData = null;
            this.reasonForReject = '';
            this.fetchAllEmployee();
          } else {
            this.$notify.warning({
              title: 'Warning',
              message: this.getFormbuilderDataUpdateError.message || 'Error while approving',
            });
            this.fetchAllEmployee();
          }
        } else {
          this.$notify.warning({
            title: 'Warning',
            message: 'You are not approver',
          });
        }
        this.loadingText = '';
        this.loading = false;
      },
      handleClick(tab, event) {
        console.log('clicked tab', tab, event);
        this.allFields = [];
        this.fetchAllEmployee();
      },
      printScope(r) {
        console.log(r);
      },
      async getNecessaryInfo() {
        this.loading = true;
        await this.fetchAllEmployee();
        this.approvalHoldName = this.getCompanyDetails?.formbuilder_approval_hold_name
          ? this.getCompanyDetails.formbuilder_approval_hold_name
          : 'HOLD';
        this.loading = false;
      },

      onEdit(row) {
        this.selectedOfferLetterTemplate = row;
        this.editDailogVisible = true;
      },
      async onView(row) {
        this.selectedOfferLetterTemplate = row;
        this.previewDialogVisible = true;
      },
      async onDelete(row) {
        this.$confirm('Are you sure to delete the response?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.deleteTemplate(row);
        });
      },
      async deleteTemplate(row) {
        //deleteFormbuilderData
        await this.$store.dispatch('formbuilderData/deleteFormbuilderData', row._id);
        if (this.getFormbuilderDataDeleteStatus) {
          this.$message({
            message: 'Response deleted successfully!',
            type: 'success',
          });
          this.fetchAllEmployee();
        } else {
          this.$notify.error({
            title: 'Error',
            message: "Something went wrong. Can't delete.",
          });
        }
      },

      async updateUserQuery(value) {
        this.$router.replace({
          name: this.$route.name,
          params: this.$route.params,
          query: { ...this.$route.query, user_id: value },
        });

        await this.getNecessaryInfo();
      },
      async fetchAllEmployee() {
        this.loading = true;
        this.data = [];
        if (this.fromAppliedFilter) {
          await this.updateStatus();
        }
        let params = {
          page: this.currentPage,
          limit: this.pageSize,
          include_template_details: false,
          include_user_details: true,
          include_formbuilder_details: true,
        };
        if (this.activeTab == 'hold') {
          params.include_hold = true;
          params.include_need_to_be_approved = true;
        } else if (this.activeTab == 'approved') {
          params.include_approval_status = 'APPROVED';
        } else if (this.activeTab == 'rejected') {
          params.include_approval_status = 'REJECTED';
        } else if (this.activeTab == 'need_to_be_approved') {
          params.include_need_to_be_approved = true;
        } else {
          params.include_need_to_be_approved = false;
        }
        if (this.fromAppliedFilter && this.getApprovalFormIds?.length) {
          params.selected_formbuilders = this.getApprovalFormIds;
        }
        if (this.selectedFilterFormbuilderids?.length) {
          params.selected_formbuilders = this.selectedFilterFormbuilderids;
        }
        if (this.approvedAtFilter) {
          if (this.approvedAtFilter === 'custom_date_range' && this.adjustedApprovedAtDateRange) {
            params['approved_at'] = this.adjustedApprovedAtDateRange;
          } else {
            const dateFilter = this.getDatePickerHelper1(this.approvedAtFilter, new Date());
            params['approved_at'] = dateFilter.value;
          }
        }
        if (this.rejectedAtFilter) {
          if (this.rejectedAtFilter === 'custom_date_range' && this.adjustedRejectedAtDateRange) {
            params['rejected_at'] = this.adjustedRejectedAtDateRange;
          } else {
            const dateFilter = this.getDatePickerHelper1(this.rejectedAtFilter, new Date());
            params['rejected_at'] = dateFilter.value;
          }
        }
        await Promise.all([
          this.$store.dispatch('formbuilderData/fetchUsersApprovalFormbuilderData', params),
          this.$store.dispatch('formbuilderData/fetchUsersApprovalFormbuilderCount', params),
        ]);
        if (!this.selectedTableFields?.length) {
          this.selectedTableFields = [
            'form_name',
            'user_email',
            'user_name',
            'approval_status',
            'sent_status',
            'completion_status',
            'due_date',
          ];
        }
        this.currentPage = parseInt(this.getFetchUsersApprovalFormbuilderData.page) || 1;
        this.total = parseInt(this.getFetchUsersApprovalFormbuilderData.data.length) || 0;

        if (
          this.getFetchUsersApprovalFormbuilderData.data &&
          this.getFetchUsersApprovalFormbuilderData.data.length
        ) {
          this.data = this.getFetchUsersApprovalFormbuilderData.data;
          this.haveOneFormbuilder = this.data.every(
            (item) =>
              item?.formbuilders_details_id?._id === this.data[0]?.formbuilders_details_id?._id
          );
          this.getFormbuilderUserData(this.data);
          this.approver = this.getFetchUsersApprovalFormbuilderData.approver || '';
        } else {
          this.approver = '';
          this.data = [];
          this.haveOneFormbuilder = false;
          this.selectedTableFields = [
            'form_name',
            'user_email',
            'user_name',
            'approval_status',
            'sent_status',
            'completion_status',
            'due_date',
          ];
        }
        if (this.getFetchUsersApprovalFormbuilderCount.data) {
          this.needToApproveCount = this.getFetchUsersApprovalFormbuilderCount.data.pending;
          this.approvedCount = this.getFetchUsersApprovalFormbuilderCount.data.approved;
          this.rejectedCount = this.getFetchUsersApprovalFormbuilderCount.data.rejected;
          this.needToApproveOthersCount =
            this.getFetchUsersApprovalFormbuilderCount.data.pendingByOthers;
          this.holdCount = this.getFetchUsersApprovalFormbuilderCount.data.holdCount;
        }
        if (this.activeTab == 'hold') {
          this.total = this.holdCount;
        } else if (this.activeTab == 'approved') {
          this.total = this.approvedCount;
        } else if (this.activeTab == 'rejected') {
          this.total = this.rejectedCount;
        } else if (this.activeTab == 'need_to_be_approved') {
          this.total = this.needToApproveCount;
        } else if (this.activeTab == 'waiting_for_others') {
          this.total = this.needToApproveOthersCount;
        }
        this.allFormbuildersDetails = [
          ...new Map(
            this.data.map((item) => [
              JSON.stringify(item?.formbuilders_details_id),
              item?.formbuilders_details_id,
            ])
          ).values(),
        ];
        if (this.haveOneFormbuilder) {
          this.selectedColumnFields = [];
          await this.$store.dispatch('formBuilders/fetchFormBuilderByCode', {
            code: this.allFormbuildersDetails[0].code,
            include_template_details: true,
            include_entity_details: true,
            include_documents_details: true,
          });
          this.currentFormbuilderDetails = this.getFormBuilder;
          let systemColumns = {
            id: 'system_column',
            label: 'System Columns',
            children: [
              {
                id: 'form_name',
                key: 'form_name',
                label: 'Form Name',
              },
              {
                id: 'user_name',
                key: 'user_name',
                label: 'User Name',
              },
              {
                id: 'user_email',
                key: 'user_email',
                label: 'User email / User IP Address',
              },
              {
                id: 'approval_status',
                key: 'approval_status',
                label: 'Approval Status',
              },
              {
                id: 'sent_status',
                key: 'sent_status',
                label: 'Sent Status',
              },
              {
                id: 'completion_status',
                key: 'completion_status',
                label: 'Completion Status',
              },
              {
                id: 'due_date',
                key: 'due_date',
                label: 'Due Date',
              },
            ],
          };
          this.selectedColumnFields.push(systemColumns);
          this.selectedTableFields = this.currentFormbuilderDetails?.column_settings || [];
          let entities = this.currentFormbuilderDetails.steps.filter(
            (step) => step.type == 'ENTITY'
          );
          let templates = this.currentFormbuilderDetails.steps
            .filter((step) => step.type == 'TEMPLATE' && !step?.settings?.is_repeatable)
            .map((step) => step.template);
          entities.forEach((entity) => {
            let entityFields = {
              id: entity.slug,
              label: entity.entity.name,
              children: [],
            };
            let allowedTemplates = entity?.settings?.selectedTemplates
              ? entity.settings.selectedTemplates
              : [];
            if (entity?.entity?.templates) {
              entity.entity.templates.forEach((template) => {
                if (
                  template?.template_id?._id &&
                  !template.is_repeatable &&
                  allowedTemplates.indexOf(template?.template_id?._id) != -1
                ) {
                  let fields = this.getTemplateFields(
                    template.template_id,
                    'ENTITY',
                    entity.entity
                  );
                  let templateFields = {
                    id: template.template_id.slug,
                    label: template.template_id.name,
                    children: fields.map((f) => {
                      return {
                        id: f.key,
                        key: f.key,
                        label: f.label.includes(' - ') ? f.label.split(' - ')?.[2] : f.label,
                        input_type: f.input_type,
                      };
                    }),
                  };
                  entityFields.children.push(templateFields);
                  this.templateFields.push({
                    fields: fields,
                    label: entity.entity.name + '-' + template.template_id.name,
                    key: template._id,
                    entity_id: entity._id,
                  });
                  this.allFields = this.allFields.concat(fields);
                }
              });
            }
            this.selectedColumnFields.push(entityFields);
          });
          this.templateIds = templates.map((template) => template._id);
          this.templateFields = [
            ...this.templateFields,
            ...templates.map((template) => {
              template.fields = this.getTemplateFields(template, 'TEMPLATE');
              this.selectedColumnFields.push({
                id: template.slug,
                label: template.name,
                children: template.fields.map((f) => {
                  return {
                    id: f.key,
                    label: f.label.includes(' - ') ? f.label.split(' - ')?.[1] : f.label,
                    input_type: f.input_type,
                    key: f.key,
                  };
                }),
              });
              this.allFields = this.allFields.concat(template.fields);
              template.label = template.name;
              template.key = template._id;
              return template;
            }),
          ];
        }
        this.loading = false;
      },
      getTemplateFields(data, type, entity = {}) {
        let fields = [];
        data.sections.forEach((e) => {
          fields = [...fields, ...e.fields];
        });
        fields = fields.map((e) => {
          e.template_id = data._id;
          e.template_title = data.name;
          e.checked = true;
          e.table_display = true;
          e.type = type;
          if (type == 'ENTITY' && entity?._id) {
            e.label = entity.name + ' - ' + data.name + ' - ' + e.label;
            e.data_key = entity._id + '#' + data._id + '#' + e.key;
            e.key = entity._id + '#' + data._id + '#' + e.key;
            e.entity_type_id = entity._id;
          } else {
            e.data_key = data._id + '#' + e.key;
            e.key = data._id + '#' + e.key;
            e.label = data.name + ' - ' + e.label;
          }
          return e;
        });
        return fields;
      },
      async handleSizeChange(val) {
        this.loading = true;
        this.pageSize = val;
        this.currentPage = 1;
        await this.fetchAllEmployee();
        this.loading = false;
      },
      async handleCurrentChange(val) {
        this.loading = true;
        this.currentPage = val;
        await this.fetchAllEmployee();
        this.loading = false;
      },
      backToWorkFlows() {
        this.$router.push({ path: '/formBuilders' });
      },
      parseFirstTemplateData(data) {
        let modifiedData = data.map((e) => {
          let dataObject = {
            _id: e._id,
            name: e.name,
            code: e.code,
            formbuilder_data_status: e.formbuilder_data_status,
            workflow_data_sender_status: e.workflow_data_sender_status,
          };

          let firstTemplateData = e.template_data_ids.find(
            (x) => x.template_id._id == this.firstTemplateId
          );

          if (firstTemplateData) {
            let firstTemplateValues =
              firstTemplateData.template_data_id && firstTemplateData.template_data_id.template_data
                ? firstTemplateData.template_data_id.template_data
                : {};
            dataObject.template_data = firstTemplateValues;
          } else {
            dataObject.template_data = {};
          }

          return dataObject;
        });
        return modifiedData;
      },
      async fetchAllConfigurableDocuments() {
        this.documentsLoading = true;
        await this.$store.dispatch('configurableDocuments/fetchConfigurableDocuments', {
          get_all: true,
          type: 'FORM',
        });
        this.documentsLoading = false;
      },
      copyURL(url) {
        navigator.clipboard.writeText(url);
        this.$message({
          message: 'Link copied successfully!',
          type: 'success',
        });
      },

      async generateFormbuilderPublicURL() {
        try {
          this.loading = true;
          await this.$store.dispatch('formBuilders/fetchWorkFlowPublicURL', {
            formbuilder_details_id: this.getFormBuilder._id,
          });

          this.workFlowPublicURL = this.getFormBuilderPublicURLDetails.public_url;
          this.false = true;
        } catch (err) {
          console.log('generateFormbuilderPublicURL', err);
        }
      },
      async loadData(data) {
        if (this.data && this.data.length) {
          this.pageSize = data.pageSize;
          this.page = data.page;
          await this.fetchAllEmployee();
        }
      },

      async selectDocuemnt(doc) {
        this.selectedConfigurableDocument = doc;
      },
      async viewFormbuilderData(row) {
        await this.$store.commit('formBuilders/setFormBuilderPrevRouter', window.location.href, {
          root: true,
        });
        if (row?.formbuilders_details_id?.code) {
          this.$router.push({
            name: 'FormbuilderView',
            params: {
              formbuilder_code: row.formbuilders_details_id.code,
              formbuilder_data_id: row._id,
            },
            query: {
              origin: 'ckjwdiuv',
              fromApprovalTabs: true,
            },
          });
        }
      },
      async editWorkUserData(row) {
        await this.$store.commit('formBuilders/setFormBuilderPrevRouter', window.location.href, {
          root: true,
        });
        if (row?.formbuilders_details_id?.code) {
          this.$router.push({
            name: 'FormbuilderEdit',
            params: {
              formbuilder_code: row.formbuilders_details_id.code,
              formbuilder_data_id: row._id,
            },
            query: {
              origin: 'ckjwdiuv',
              fromApprovalTabs: true,
            },
          });
        }
      },
      getFlowName() {
        return this.getFormBuilder?.name;
      },

      getFieldData(templateData, field) {
        if (templateData[field.key]) {
          if (field.input_type == 'DATE') {
            return this.$moment.utc(templateData[field.key]).format('MM-DD-YYYY');
          }
          return templateData[field.key];
        }
        return '-';
      },
      validateRequiredFields(entityData, allCustomizedFormBuilderFields) {
        let missingFields = [];
        for (let field of allCustomizedFormBuilderFields) {
          const [entityId, templateId, fieldName] = field.data_key?.split('#') || [];
          const key = templateId && fieldName ? `${templateId}#${fieldName}` : null;
          const value = key ? entityData?.[entityId]?.[key] : null;

          if (this.checkIsRequired(field)) {
            if (field.input_type === 'ENTITY_TABLE') {
              if (!value || !value.length) {
                missingFields.push(field.label);
              }
            } else {
              if (
                value === undefined ||
                value === null ||
                value === '' ||
                value === 'NaN' ||
                (Array.isArray(value) && value.length === 0) ||
                (typeof value === 'object' &&
                  !Array.isArray(value) &&
                  Object.keys(value).length === 0)
              ) {
                missingFields.push(field.label);
              }
            }
          }
        }

        if (missingFields.length) {
          return `${missingFields.join(', ')} field${
            missingFields.length > 1 ? 's are' : ' is'
          } required.`;
        }
        return null;
      },
      checkIsRequired(data) {
        if (data.allow_multiple) {
          if (data.min_value > 0) {
            return true;
          }
          return false;
        }
        return data?.validations?.required ? true : false;
      },
    },
    watch: {
      '$route.params.workflow_code': async function () {
        await this.getNecessaryInfo();
      },
      async '$route.query.key'() {
        this.getNecessaryInfo();
      },
      async '$route.params.formbuilder_code'() {
        this.getNecessaryInfo();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .add-buttons {
    border: 1.5px solid #285ed3;
    box-sizing: border-box;
    border-radius: 2px;
    padding: 0.45em 0.65em;
    color: #285ed3;

    &:hover {
      background-color: #285ed3;
      color: #ffffff;
      border-color: #285ed3;
    }
  }

  #workflow-users-list {
    .el-dialog__body {
      padding: 20px 20px;

      .el-card {
        .el-card__body {
          padding: 10px;
        }

        &:not(:last-child) {
          margin-bottom: 20px;
        }
      }
    }
  }

  .doc {
    min-width: 30px;

    &.selected {
      background: green;
    }
  }

  .green {
    color: green;
  }

  .font-17 {
    font-size: 17px;
    cursor: pointer;
  }

  .documents {
    min-height: 200px;
    max-height: 400px;
    overflow: scroll;
  }

  .el-table .cell {
    word-break: break-word;
  }

  .el-table .td {
    word-wrap: break-word;
  }

  .count-circle {
    display: inline-block;
    width: 24px;
    height: 24px;
    color: #fff;
    /* Text color */
    border-radius: 50%;
    /* Make it circular */
    text-align: center;
    line-height: 24px;
    /* Vertically center the text */
    font-size: 12px;
    /* Adjust font size as needed */
    position: relative;
    /* Add positioning */
    // top: -6px; /* Adjust position as needed */
    left: 4px;
    /* Adjust position as needed */
  }

  .approver-text {
    color: #3366cc;
  }

  .list-style {
    margin-top: 10px;
  }

  .expired-div {
    color: #dc3545;
  }

  .approval-form {
    margin-top: -25px;
  }

  .container {
    display: flex;
    align-items: center;
  }

  .filter-container {
    display: flex;
    align-items: center;
  }

  .filter-icon-box {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 27px;
    height: 25px;
    border: 1px solid #ccc;
    border-radius: 4px;
    margin-right: 6px;
    background-color: #f8f8f8;
  }

  .filter-icon-box i {
    font-size: 16px;
    color: #333;
  }

  .custom-pagination {
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .expand-loading-wrapper {
    min-height: 100px;
  }

  .expand-content {
    padding: 1.25rem;
    max-width: 62.5rem;
    margin-left: 6.25rem;
  }

  .template-section {
    margin-bottom: 1.25rem;
  }

  .template-title {
    margin: 0 0 0.75rem 0;
    font-weight: 500;
    font-size: 1.25rem;
    color: #000;
    padding-bottom: 0.25rem;
  }

  .template-header {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 0.625rem;
    padding-bottom: 0.625rem;
    margin-bottom: 0.625rem;
    border-bottom: 0.03125rem solid #ccc;
  }

  .field-item {
    display: flex;
    gap: 0.3125rem;
    align-items: center;
  }

  .image-field {
    height: 40px;
    width: 100px;
  }

  ::v-deep #el-drawer__title span[role='heading'] {
    font-size: 1.3rem;
    font-weight: 500;
  }
  ::v-deep(.custom-large-stars .el-rate__icon) {
    font-size: 26px !important;
  }
</style>
